/*Seccion imports: Componentes*/ 
import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol} from '../componentes_generales/componentes_formulario/contenedores/';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import PuntoFacturacion from '../ventas/puntoFacturacion';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import { LabelForm, LabelNota, LabelNotaConEstilo, LabelNormal, LabelTotales, LabelValorTotales } from '../componentes_generales/componentes_formulario/labels';
import styled from 'styled-components';
import moment from 'moment';
import ToggleSwitch from '@trendmicro/react-toggle-switch';
import '@trendmicro/react-toggle-switch/dist/react-toggle-switch.css';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import SelectArticulo from '../inventario/selectArticulo';
import DocumentosGeneradosPorImprimir from './docsGeneradPorImprimir';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

/*Seccion imports: Funciones*/
import global_axios from '../../funciones_globales/interaccionapi';
import {
    esEmailValido, esNumero,
    validarFechaMomentEnFormatoString,
    validarJSON,
    validarStringConAnchoMinimo
} from '../../funciones_globales/utils';
import { obtenerParametros, obtenerSecuencial } from '../../funciones_globales/parametros';
import { cargarCatalogos, cargarCatalogosGenericoAsync, generarItemCatalogoSeleccionado, cargarCatalogoEstados } from '../../funciones_globales/catalogos';
import { validarCampoString, validarFechaTransaccionSeleccionada } from '../../funciones_globales/utils';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { completar_String, formatearNumeroDecimal, formatearNumeroEntero, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { multiplicarDecimales } from '../../funciones_globales/operacionesMatematicas';
import {visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { cargar_Articulo } from '../../actions/inventario/act_inven01';
import { cargar_Proformas, setDocumentosPorImprimir } from '../../actions/ventas/act_ven02';
import {validarAccesoATransaccion} from "../../funciones_globales/accionesPorUsuario";
import { MOTIVO_CAMBIO_VACIO } from '../../app.constants';
import {detectarNavegador} from "../../funciones_globales/deteccionNavegador";


/*
Esta pantalla está orientada a generar proformas.
Una proforma puede ser generada tomando un pedido móvil o un pedido de devolución por garantía, así como también
se permite agregar items manualmente a la proforma.

Cuando se importe un pedido aparecerá en pantalla todos los items del pedido, sin embargo al momento de
guardar se crearán n número de proformas de acuerdo a un número de items máximo que puede tener cada proforma.
El parámetro para este propósito está configurado en la tabla: Select NroArticulos = Convert(int, Descripcion) From dbo.Tabla (nolock) Where Tabla='ARTFAC' And Codigo='CAF';

Se trabaja con reservas de stock automáticas. Cada vez que se importe un pedido, se agregue/elimine un articulo o se modifique
una cantidad en la proforma se irá generando reservas en la tabla Stock y en tablas de reserva: ReservaStock, DReservaStock, ReservaStockPorBodega,
y cuando se realice modificaciones en una proforma que ya fue generada se usa la tabla: RespaldoReservaPorBodega.

En la proforma se considera dos tipos de descuento: descuento por línea de artículo y descuento general a la proforma.

En esta misma pantalla se permite generar una factura.

*/

const ContenedorModal = styled.div`
  margin-top: 20px;
  height: 400px;
  width: 770px;
`;

const ContenedorBoton = styled.div`
  padding-top: 17px;  
  @media (max-width: 991px) {
    padding-top: 0px;
  }
`;

const ContainerBtnTransac = styled.div`
  margin-top: 8px;
`;

const LabelCabecera = styled.label`
  display: inline;
  font-size: 9px;
  color: green;
  margin-right: 15px;
  float: right;
`;

const LabelTipoProf = styled.label`
  display: inline;
  font-size: 10px;
  color: green;    
`;

const ContainerAlineado = styled.div`
  display: inline;
`;

const LabelNroFactura = styled.h6`
  color: red;
  font-weight: 600;
`;

const TRX_GENERAR_PROFORMA = 'GENERAR_PROFORMA';
const TRX_MODIFICAR_CAB_PROFORMA = 'MOD_CAB_PROFORMA';
const TRX_MODIFICAR_DETALLE_PROF_AGREGAR = 'MOD_DET_PROFORMA_AGREGAR';
const TRX_MODIFICAR_DETALLE_PROF_ELIMINAR = 'MOD_DET_PROFORMA_ELIMINAR';
const TRX_MODIFICAR_DETALLE_PROF_CAMBIAR = 'MOD_DET_PROFORMA_CAMBIAR';
const TRX_MODIFICAR_DETALLE_PROF_CAMBIAR_LIMITADO = 'MOD_DET_PROFORMA_CAMBIAR_LIMITADO';
const TRX_ANULAR_PROFORMA = 'ANULAR_PROFORMA';
const TRX_FACTURAR = 'FACTURAR';
const FEATURE_OCULTAR_VALORES_PROF = 'OCULTAR_VALORES_PROF';
const FEATURE_CONSULTAR_PROF_X_IMPRIMIR = 'CONSULTAR_PROFORMAS_POR_IMPRIMIR';

const msgErrorPermisoGeneracionProforma = 'Ud. no tiene permiso para generar proformas.';
const msgErrorPermisoModificacionProforma = 'Ud. no tiene permiso para modificar proformas.';
const msgErrorPermisoModifDetalleProforma = 'Ud. no tiene permiso para modificar detalle de proformas.';
const msgErrorPermisoAnulacionProforma = 'Ud. no tiene permiso para anular proformas.';
const msgErrorPermisoFacturacion = 'Ud. no tiene permiso para generar facturas.';
const msgErrorProformaNoModificable = 'La modificación de esta proforma no está permitida por uno de los siguientes motivos: está Facturada/Anulada, es de tipo Tránsito ó tiene Encartonado.';


class FormVen02 extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      habilitarTerPago: true,
      permitirGeneracionProforma: false,
      permitirModifCabProforma: false,
      permitirModifDetProformaAgregar: false,
      permitirModifDetProformaEliminar: false,
      permitirModifDetProformaCambiar: false,
      permitirModifDetProformaCambiarLimitado: false,
      permitirAnulacionProforma: false,
      permitirFacturacion: false,
      ocultarValoresProforma: false,
      permitirConsultaProformasXImprimir: false,
      parametroDescuentoPlazo: false,
      fechaDsctoPlazo: '',
      porcentajeDsctoPlazo: 0,
      totalDsctoPlazo: 0,
      tipoPedidoMovilSeleccionado: '',
      esBotonGuardarMod: false,
      existenCambiosEnDetalle: false, // Campo para controlar si la proforma tiene cambios
      esCopiada: null, // Campo para verificar si la proforma fue copiada
      tiposCliente: [],
      formasPago: [],
      terminosPago: [],
      isVisibleModalPedidos: false,
      isVisibleModalProfPendFact: false,
      isVisibleModalProfPendImprimir: false,
      operacion: 'G', // Tipo de Operacion: (G) GUARDAR NUEVO (M) MODIFICAR
      fechaProforma: null,
      tipoCliente_sel: undefined,
      formaPago_sel: undefined,
      cliente_sel: undefined,
      vendedor_sel: undefined,
      articulo_sel: undefined,
      proformaId: '',
      secuencialProforma: '',
      reservaId: undefined,      
      diasGracia: undefined,
      cantidadArt: undefined,
      descuento: undefined,
      terminoPago_sel: undefined,
      pedidosPendientesProforma: [],
      Devolucion: null,
      pedidoSeleccionado: {},
      detalleProforma: [],
      proformaCopiadaId: '',
      porcentIva: parseFloat(0.00),
      paramPorcentajeDscto: parseFloat(0.00),
      porcentajeDscto: parseFloat(0.00),
      subtotalConIva: parseFloat(0.00),
      subtotalSinIva: parseFloat(0.00),
      total: parseFloat(0.00),
      valorIva: parseFloat(0.00),
      totalDscto: parseFloat(0.00),      
      totalDsctoLinea: parseFloat(0.00),      
      nroItemsPorProforma: formatearNumeroEntero(0),
      estadosProforma: undefined,
      estadoActual: 'P',
      cabeceraEsModificable: true,
      detalleEsModificable: true,
      direccionesCliente: [],
      direccion_sel: 0,
      esProformaServicio: false,
      precioUnitArt: '',
      descripcionArt: '',
      cajaGen: '',
      embalaje: null,
      idFactura: null,
      proformasPendFactura: [],
      isVisibleCompGenPorImp: false,
      dsctoClienteId: null,
      descuentosCliente: [],
      promocionesVigentes: [],
      isVisibleModalPromociones: false,
      itemsPromocion: [],
      pedidosMovilesNuevos: [],
      nroFactura: '',
      descripTipoProformaProd: '',
      tipoProforma: '',
      esDetallePendiente:false,
      parametroProforma:'',
      encartonadoId: '',
      articulosEliminados: [],
      pagination: {
          totalFilas: 0,
          totalFilasPorPagina: 0,
          primaraFilaPagina: 0,
          ultimaFilaPagina: 0,
      },
      colsDefListadoProformas: [
        {   header: 'No.',
            field: 'Nro',
            width: 30,
            type: 'string',
            suppressFilter: true
        },
        {   header: 'Proforma',
            field: 'Proforma',
            width: 70,
            type: 'string'
        },
        {   header: 'Cliente',
            field: 'Cliente',
            width: 195,
            type: 'string'
        },
        {   header: 'Fecha',
            field: 'Fecha',
            width: 95,
            type: 'string',
            suppressFilter: true
        },                   
        {   header: 'Total',
            field: 'Importe',
            width: 60,
            type: 'num_decimal',
            suppressFilter: true
        },
        {   header: 'Items',
            field: 'NroItems',
            width: 40,
            type: 'num_entero',
            suppressFilter: true
        },       
        {   header: 'Vendedor',
            field: 'Vendedor',
            width: 195,
            type: 'string'
        },
        {   header: 'Tipo',
            field: 'Tipo',
            width: 50,
            type: 'string',
            suppressFilter: true
        },
        {   header: 'Imp. Por Liberar',
            field: 'ImportEnTransito',
            width: 85,
            type: 'string',
            suppressFilter: true
        },
        {   header: 'Encartonado',
            field: 'EncartonadoId',
            width: 85,
            type: 'string',
            suppressFilter: true
        },
      ],
      colsDefDetProforma: [
        { header: 'Artículo',
          children: [
            { header: 'Promoc.',
              field: 'EsPromocion',
              width: 45,
              type: 'string'
            },
            { header: 'No.',
              field: 'NroItem',
              width: 40,
              type: 'string'
            },
            { header: 'Cód. Art.',
              field: 'Articulo',
              width: 73,
              type: 'string'
            },
            { header: 'Descripción',
              field: 'Descripcion',
              width: 305,
              type: 'string',
            },
          ]
        },
        { header: 'Pedido',
          children: [
            { header: 'Inicial',
              field: 'CantPedido',
              width: 70,
              type: 'num_entero'
            },
            { header: 'Vendido',
              field: 'CantPorDespachar',
              width: 70,
              type: 'num_entero_edit',
              editable: true
            },
          ]
        },
        { header: 'Stock',
          children: [
            { header: 'Stock M.',
              field: 'StockPrincipal',
              width: 70,
              type: 'num_entero'            
            },
            { header: 'Stock A.',
              field: 'StockAlterno',
              width: 70,
              type: 'num_entero'            
            },
            { header: 'Por Liberar',
              field: 'StockTransito',
              width: 70,
              type: 'num_entero',                 
            }
          ]
        },
        { header: 'Reserva/Proforma',
          children: [
            { header: 'Cant.',
              field: 'CantidadDespacho',
              width: 70,
              type: 'num_entero'              
            },                 
            { header: 'P. Unit.',
              field: 'PrecioUnit',
              width: 70,
              type: 'num_decimal3',
            },
            { header: '% Dscto Linea.',
              field: 'Descuento',
              width: 70,
              type: 'num_decimal'
            },
            { header: 'Total',
              field: 'Total',
              width: 90,
              type: 'num_decimal',

              valueGetter: (params) => {
                /* Cálculo del subotal de cada item de la proforma, se considera el descuento por línea de artículo */
                let cantidad = parseFloat(Number.isNaN(params.data.CantidadDespacho)? 0: params.data.CantidadDespacho);
                let precioUnit = parseFloat(Number.isNaN(params.data.PrecioUnit)? 0: params.data.PrecioUnit);
                let porcDescuento = parseFloat(Number.isNaN(params.data.Descuento)? 0: params.data.Descuento);
                let porcDescuentoPlazo= params.data.Articulo.trim()==='EMBA'?0:this.state.porcentajeDsctoPlazo;
              
                let precioUnitDsctoPlazo=  parseFloat(multiplicarDecimales(precioUnit, porcDescuentoPlazo/100));
                let precioUnitDescontadoPlazo = parseFloat(parseFloat(precioUnit)-parseFloat(precioUnitDsctoPlazo));
                let precioUnitDscto = parseFloat(multiplicarDecimales(precioUnitDescontadoPlazo, porcDescuento/100));
                let precioUnitDescontado = parseFloat(parseFloat(precioUnitDescontadoPlazo)-parseFloat(precioUnitDscto)); 
                let subTotalItem = parseFloat(multiplicarDecimales(cantidad, precioUnitDescontado)).toFixed(2);

                return subTotalItem;
              }
            }
          ]
        },
        {  header: 'Log. Cambios',
           children: [
               { header: 'Motivo Cambio',
                 field: 'MotivoCambio',
                 width: 125,
                 hide: true,
                 editable: true,
                 cellEditor: 'select',
                 cellEditorParams: {
                       values: JSON.parse(getItemDatosSesion('motivosCambioProf'))
                 }
               }
           ]
        }
      ],
      colsDefPedidos: [
        {   header: 'No.',
            field: 'NroItem',
            width: 30,
            type: 'string',
            suppressFilter: true,
        },
        {   header: 'Pedido',
            field: 'Pedido',
            width: 65,
            type: 'string'
        },
        {   header: 'Cliente',
            field: 'Cliente',
            width: 220,
            type: 'string'
        },
        {   header: 'Fecha',
            field: 'Fecha',
            width: 105,
            type: 'string',
            suppressFilter: true
        },                   
        {   header: 'Total',
            field: 'Total',
            width: 65,
            type: 'num_decimal',
            suppressFilter: true
        },
        {   header: 'Items',
            field: 'Items',
            width: 45,
            type: 'num_entero',
            suppressFilter: true
        },
        {   header: 'It. Pend.',
            field: 'ItemsPend',
            width: 50,
            type: 'num_entero',
            suppressFilter: true
        },
        {   header: 'Cód. Vend.',
            field: 'Vendedor',
            width: 65,
            type: 'string',
            suppressFilter: true
        },
        {   header: 'Estado',
            field: 'Estado',
            width: 75,
            type: 'string'
        },
        {   header: 'Devolución',
            field: 'Devolucion',
            width: 70,
            type: 'string'
        }
      ],
      colsDefItemsPromocion: [
        {   header: 'No.',
            field: 'NroItem',
            width: 35,
            type: 'string',
            suppressFilter: true            
        },
        {   header: 'Artículo',
            field: 'Articulo',
            width: 60,
            type: 'string'
        },
        {   header: 'Descripción',
            field: 'Descripcion',
            width: 190,
            type: 'string'
        },
        {   header: 'Marca',
            field: 'Marca',
            width: 110,
            type: 'string'
        },
        {   header: 'Linea',
            field: 'TipoCompra',
            width: 160,
            type: 'string'
        },
        {   header: 'Precio',
            field: 'Precio',
            width: 60,
            type: 'num_decimal',            
            suppressFilter: true
        },
        {   header: 'Stock',
            field: 'Stock',
            width: 60,
            type: 'num_entero',
            suppressFilter: true
        },
        {   header: 'Cant. Promoc.',
            field: 'CantPromocion',
            width: 70,
            type: 'num_entero_edit',
            editable: true,
            suppressFilter: true
        }
      ],
      colsDefPedidosNuevos: [
        {   header: 'No.',
            field: 'NroItem',
            width: 30,
            type: 'string',
            suppressFilter: true,
        },
        {   header: 'Pedido',
            field: 'Pedido',
            width: 60,
            type: 'string'
        },
        {   header: 'Cliente',
            field: 'Cliente',
            width: 210,
            type: 'string'
        },
        {   header: 'Fecha Ped.',
            field: 'FechaPed',
            width: 100,
            type: 'string',
            suppressFilter: true
        },
        {   header: 'Fecha Ing. Sist.',
            field: 'FechaIngSist',
            width: 100,
            type: 'string',
            suppressFilter: true
        },
        {   header: 'Total',
            field: 'Total',
            width: 60,
            type: 'num_decimal',
            suppressFilter: true
        },
        {   header: 'Items',
            field: 'Items',
            width: 40,
            type: 'num_entero',
            suppressFilter: true
        },        
        {   header: 'Vendedor',
            field: 'Vendedor',
            width: 210,
            type: 'string',            
        },
        {   header: 'Estado',
            field: 'Estado',
            width: 70,
            type: 'string'
        }        
      ],

      gridDetProformaApi: null,
      gridDetProformaColumnApi: null
    };

    this.gridDetProformaOptions = {
      enableColResize: true,
      enableCellChangeFlash: true,
      onRowDataChanged: (()=>{
        /* Cada vez que el grid de detalle sufra un cambio se recalcularán los totales*/
        this.calculoTotales();
      }),
      rowSelection: 'single',
      rowDeselection: 'true',
      singleClickEdit: true,
      onCellValueChanged: ((event)=>{
        let eventData = { valorAnterior: formatearNumeroEntero(event.oldValue),
                          valorNuevo: formatearNumeroEntero(event.newValue),
                          itemProforma: event.data
                        };
        
        let columna = event.colDef.field;
        /* Actualización de la reserva de stock en caso de que se modifique la cantidad a pedir de un artículo */
        if (columna === 'CantPorDespachar'){
          if(isNaN(eventData.valorNuevo) || formatearNumeroEntero(eventData.valorNuevo)===0){
            alert('La cantidad que ingresó es incorrecta.');
            event.data.CantPorDespachar = eventData.valorAnterior;
            this.state.gridDetProformaApi.refreshCells();
          }else if (eventData.valorNuevo !== eventData.itemProforma.CantidadDespacho){
              let aplicarCambio = true;

              /* Validacion de permisos */
              if (this.state.operacion==='M') {
                  let esIncremento = eventData.valorNuevo > eventData.itemProforma.VendidoOriginal;
                  if(esIncremento) {
                      if (!this.state.permitirModifDetProformaCambiar) {
                          aplicarCambio = false;
                          event.data.CantPorDespachar = eventData.valorAnterior;
                          this.state.gridDetProformaApi.refreshCells();
                          alert(msgErrorPermisoModifDetalleProforma + ' No puede añadir más unidades que la cantidad ya asignada: ' + eventData.itemProforma.VendidoOriginal);
                      }
                  }else {
                      if (! (   this.state.permitirModifDetProformaCambiar ||
                                this.state.permitirModifDetProformaCambiarLimitado) ) {
                          aplicarCambio = false;
                          event.data.CantPorDespachar = eventData.valorAnterior;
                          this.state.gridDetProformaApi.refreshCells();
                          alert(msgErrorPermisoModifDetalleProforma + ' No puede disminuir unidades.');
                      }
                  }
              }

              if(aplicarCambio) {
                  // Si se realiza cambios en el grid de items se setea el campo existenCambiosEnDetalle y se actualiza la reserva.
                  this.setState({existenCambiosEnDetalle: true});
                  this.actualizarReservaArticulo(eventData);
              }
          }
        }
      }),

      onCellEditingStarted: (event=>{

        /* Validacion de permisos */
        if (this.state.operacion==='M') {
            if(!(this.state.permitirModifDetProformaCambiar || this.state.permitirModifDetProformaCambiarLimitado)) {
                this.state.gridDetProformaApi.stopEditing(true);
                alert(msgErrorPermisoModifDetalleProforma);
                return;
            }
        }

        /* Control para no permitir la modificación de una proforma */
        if (this.state.operacion==='M' && this.state.detalleEsModificable===false){
            this.state.gridDetProformaApi.stopEditing(true);
            alert(msgErrorProformaNoModificable);
            return;
        }

        if (!event.data.EsEditable){          
          this.state.gridDetProformaApi.stopEditing(true);
          alert('La modificación de este artículo no está permitida.');
          return;
        }

        if (this.state.tipoProforma === 'T' && event.data.CantidadDespachoOrig !== 0 && event.data.ImportacionXLiberar !== 0) {
            this.state.gridDetProformaApi.stopEditing(true);
            alert('Artículo con importación no liberada. La modificación no está permitida.');
            return;
        }

      }),

      onCellDoubleClicked: ((event)=>{        
        if(event.column.colId==='Articulo' || event.column.colId==='Descripcion'){
          let codArticulo = event.data.Articulo;
          visualizarReporteEnPdf('&rpt=31&param1=' + codArticulo);
        }
      }),

      suppressScrollOnNewData: true
    };

    this.gridPedidosOptions = {
      rowSelection: 'single',
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,

    /* Se podrá importar pedidos moviles o pedidos de devolución por garantía */
    onRowDoubleClicked: (event)=>{
        if(!this.state.permitirGeneracionProforma) {
          alert(msgErrorPermisoGeneracionProforma);
          return;
        }

        let idPedido = event.node.data.Pedido;
        let devolucion = event.node.data.Devolucion;
        if (validarCampoString(devolucion, 6)){
          this.importarPedido(idPedido, 'PD', () => this.setState({ isVisibleModalPedidos: !this.state.isVisibleModalPedidos })); // Pedido de Devolucion por Garantia
        }else{
          this.importarPedido(idPedido, 'PM', () => this.setState({ isVisibleModalPedidos: !this.state.isVisibleModalPedidos })); // Pedido Movil
        }
    },
      getRowStyle: (params) =>{
        if (params.data.Devolucion !== '') {
          return {'background-color': '#FAFAD2'}
        }
        return null;
      }
    };

    this.gridProfPendFactOptions = {
      rowSelection: 'single',
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      
      /* Se podrá importar proformas pendientes de facturar */
      onRowDoubleClicked: (event)=>{
        // Validacion de permiso
        if(!this.state.permitirFacturacion){
            alert(msgErrorPermisoFacturacion);
            return;
        }

        let proformaId = event.data.Proforma;
        if(event.data.Tipo==='PT'){
          if (event.data.ImportEnTransito==='SI'){
            alert('La profoma No. ' + proformaId + ' está relacionada con una importación por liberar. No puede continuar con la generación de la factura hasta que la importación sea liberada.');
            return;
          }
          if (event.data.ImportEnTransito==='AN'){
            alert('La profoma No. ' + proformaId + ' está relacionada con una importación por liberar anulada. No puede generar la factura.');
            return;
          }
        }
        this.setState({proformaId, isVisibleModalProfPendFact: !this.state.isVisibleModalProfPendFact});
        this.getProformaById();
      }
    };

    this.gridProfPendImprimirOptions = {
      rowSelection: 'single',
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,

      onRowDoubleClicked: (event) => {
          let proformaId = event.data.Proforma;
          this.setState({ proformaId, isVisibleModalProfPendImprimir: false }, () => this.getProformaById());
      }
    };

    this.gridItemsPromocion = {
      enableColResize: true,
      enableFilter: true,
      enableSorting: true,
      getRowStyle: (params) =>{
        if (validarCampoString(params.data.CantPromocion, 1, 3)){
          return {'background-color': '#FAFAD2'}
        }
        return null;
      }
    };

    this.gridPedidosNuevosOptions = {
      enableColResize: true,
      enableFilter: true,
      enableSorting: true
    };

    this.onGridDetProformaReady = this.onGridDetProformaReady.bind(this);
    this.procesarConsultaPedidos = this.procesarConsultaPedidos.bind(this);
    this.importarPedido = this.importarPedido.bind(this);
    this.cambiarVisualizacionModalPedidos = this.cambiarVisualizacionModalPedidos.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.limpiar = this.limpiar.bind(this);
    this.handleAddArticulo = this.handleAddArticulo.bind(this);
    this.handleDeleteArticulo = this.handleDeleteArticulo.bind(this);
    this.immutablePush = this.immutablePush.bind(this);
    this.guardarProforma = this.guardarProforma.bind(this);
    this.calculoTotales = this.calculoTotales.bind(this);
    this.actualizarReservaArticulo = this.actualizarReservaArticulo.bind(this);
    this.getClientebyId = this.getClientebyId.bind(this);
    this.getProformaById = this.getProformaById.bind(this);
    this.replicarProforma = this.replicarProforma.bind(this);
    this.validarGeneracionFactura = this.validarGeneracionFactura.bind(this);
    this.generarFactura = this.generarFactura.bind(this);    
    this.imprimirProforma = this.imprimirProforma.bind(this);
    this.imprimirFactura = this.imprimirFactura.bind(this);
    this.cambiarVisualizacionModalProfPendFact = this.cambiarVisualizacionModalProfPendFact.bind(this);
    this.procesarConsultaProfPendFacturar = this.procesarConsultaProfPendFacturar.bind(this);
    this.anularProforma = this.anularProforma.bind(this);
    this.aplicarDescuentosPorCliente = this.aplicarDescuentosPorCliente.bind(this);    
    this.cambiarVisualizacionModalPromociones = this.cambiarVisualizacionModalPromociones.bind(this);
    this.verificarPromocionesAplicadas = this.verificarPromocionesAplicadas.bind(this);
    this.generarItemsPromocionEnProforma = this.generarItemsPromocionEnProforma.bind(this);
    this.cambiarEstadoPedidoMovil = this.cambiarEstadoPedidoMovil.bind(this);
    this.changeFormaPago = this.changeFormaPago.bind(this);
    this.generarProformasNuevas = this.generarProformasNuevas.bind(this);
    this.generarProformaModificada = this.generarProformaModificada.bind(this);
    this.registrarEventoDeProforma = this.registrarEventoDeProforma.bind(this);
  }
  
  handleInputChange(event){
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.setState({
      [name]: value
    });
  }

  /* Esta función muestra el modal de los pedidos pendientes de proforma que se pueden importar */
  cambiarVisualizacionModalPedidos(){    
    if (this.state.esProformaServicio){
      alert('Ud. está realizando una proforma de servicios. No puede importar pedidos.')
      return;
    }

    if (this.state.isVisibleModalPedidos===false){
      this.procesarConsultaPedidos();
    }

    this.limpiar(()=>this.setState({ isVisibleModalPedidos: true}));
  }

  onGridDetProformaReady(params){
    this.setState({gridDetProformaApi: params.api});
    this.setState({gridDetProformaColumnApi: params.columnApi});
  }

  /* Cuando se inicia la pantalla se cargan también todos los parámetros necesarios para el funcionamiento de la misma */
  componentDidMount() {
    const perfilId = JSON.parse(getItemDatosSesion('perfil')).Id;
    Promise.all([
        validarAccesoATransaccion(TRX_GENERAR_PROFORMA, getItemDatosSesion('usuario'), perfilId),
        validarAccesoATransaccion(TRX_MODIFICAR_CAB_PROFORMA, getItemDatosSesion('usuario'), perfilId),
        validarAccesoATransaccion(TRX_MODIFICAR_DETALLE_PROF_AGREGAR, getItemDatosSesion('usuario'), perfilId),
        validarAccesoATransaccion(TRX_MODIFICAR_DETALLE_PROF_ELIMINAR, getItemDatosSesion('usuario'), perfilId),
        validarAccesoATransaccion(TRX_MODIFICAR_DETALLE_PROF_CAMBIAR, getItemDatosSesion('usuario'), perfilId),
        validarAccesoATransaccion(TRX_MODIFICAR_DETALLE_PROF_CAMBIAR_LIMITADO, getItemDatosSesion('usuario'), perfilId),
        validarAccesoATransaccion(TRX_ANULAR_PROFORMA, getItemDatosSesion('usuario'), perfilId),
        validarAccesoATransaccion(TRX_FACTURAR, getItemDatosSesion('usuario'), perfilId),
        validarAccesoATransaccion(FEATURE_OCULTAR_VALORES_PROF, getItemDatosSesion('usuario'), perfilId),
        validarAccesoATransaccion(FEATURE_CONSULTAR_PROF_X_IMPRIMIR, getItemDatosSesion('usuario'), perfilId),
        cargarCatalogos('TIPOCLIEN'),
        cargarCatalogos('FORMAPAGO'),
        cargarCatalogos('TERPAGO'),
        obtenerParametros('DIASGRACIA'),
        obtenerParametros('IVAACTUAL'),
        obtenerParametros('NROARTICULOSFACT'),
        obtenerParametros('CAJAGENERAL'),
        obtenerParametros('PORCDESCUENTO'),
        this.consultarPedidosMovilesPendProforma(),
        this.consultarPedidosPorDevolucion(),
        this.consultarPedidosMovilesNuevos(),
        cargarCatalogoEstados('Pedido', 'Status'),
        obtenerSecuencial('Pedido'),
        obtenerParametros('PROFORMA'),
        cargarCatalogos('DESCUENTOPLAZO'),
        this.props.generar_LogAuditoriaIngresoForm('0402')
    ])
    .then(([accesoGenerarProforma, accesoModificarCabProforma, accesoModificarDetProformaAgregar, accesoModificarDetProformaEliminar,
            accesoModificarDetProformaCambiar, accesoModificarDetProformaCambiarLimitado, accesoAnularProforma, accesoFacturar, accesoOcultarValores,
            accesoConsultarPendientesImprimir, tiposCliente, formasPago, terminosPago, paramsDiasGracia, paramIvaActual, paramNroArticulos,
            paramCajaGen, paramPorcDscto, pedidosMoviles, pedidosPorDevolucion, pedidosMovilesNuevos, estadosProforma,
            secuencialProforma, parametroProforma, parametroDescuentoPlazo ]) => {

        let fechaProceso = getFechaProcesoPorModulo('04');
        this.setState({
          permitirGeneracionProforma: accesoGenerarProforma.accesoPermitido === true,
          permitirModifCabProforma: accesoModificarCabProforma.accesoPermitido === true,
          permitirModifDetProformaAgregar: accesoModificarDetProformaAgregar.accesoPermitido === true,
          permitirModifDetProformaEliminar: accesoModificarDetProformaEliminar.accesoPermitido === true,
          permitirModifDetProformaCambiar: accesoModificarDetProformaCambiar.accesoPermitido === true,
          permitirModifDetProformaCambiarLimitado: accesoModificarDetProformaCambiarLimitado.accesoPermitido === true,
          permitirFacturacion: accesoFacturar.accesoPermitido === true,
          permitirAnulacionProforma: accesoAnularProforma.accesoPermitido === true,
          ocultarValoresProforma: accesoOcultarValores.accesoPermitido === true,
          permitirConsultaProformasXImprimir: accesoConsultarPendientesImprimir.accesoPermitido === true,
          tiposCliente, formasPago, terminosPago, formaPago_sel: 'CR',
          pedidosPendientesProforma: pedidosMoviles.concat(pedidosPorDevolucion) , pedidosMovilesNuevos, estadosProforma,
          porcentIva: parseFloat(paramIvaActual[0].IvaActual), nroItemsPorProforma: formatearNumeroEntero(paramNroArticulos[0].NroArticulos),
          paramPorcentajeDscto: parseFloat(paramPorcDscto[0].PorcDescuento),
          porcentajeDscto: parseFloat(paramPorcDscto[0].PorcDescuento),
          cajaGen: paramCajaGen[0].CajaGeneral,
          diasGracia: this.generarDiasGracia(paramsDiasGracia),
          fechaProforma: moment(fechaProceso, 'DD/MM/YYYY'),
          secuencialProforma: completar_String((secuencialProforma.codigo - 1).toString(), '0', 6),
          parametroProforma: parametroProforma[0].Observacion,
          parametroDescuentoPlazo: parametroDescuentoPlazo[0].referencia==='S',
          fechaDsctoPlazo: parametroDescuentoPlazo[0].observacion
        }, () => {
            if(this.state.ocultarValoresProforma) {
                this.state.gridDetProformaColumnApi.setColumnVisible('StockPrincipal', false);
                this.state.gridDetProformaColumnApi.setColumnVisible('StockAlterno', false);
                this.state.gridDetProformaColumnApi.setColumnVisible('StockTransito', false);
                this.state.gridDetProformaColumnApi.setColumnVisible('PrecioUnit', false);
                this.state.gridDetProformaColumnApi.setColumnVisible('Descuento', false);
                this.state.gridDetProformaColumnApi.setColumnVisible('Total', false);
            }
        });

        this.consultarPromocionesVigentes(fechaProceso);
    })
    .catch(error => {
      alert(error);
    });
  }

  generarDiasGracia(paramsDiasGracia){
    let diasGracia = null;
    let diasGraciaDefault = null;

    if (paramsDiasGracia){
      // Extraer el mes de la fecha de proceso en formato: 'dd/mm/yyyy'
      let fechaProceso = getFechaProcesoPorModulo('04');
      let mesActual = fechaProceso.toString().substr(3, 2);
      
      paramsDiasGracia.forEach((tipoGracia)=>{
        if (tipoGracia.Codigo === 'GRACI'){
          diasGraciaDefault = tipoGracia.DiasGracia;
        }
        
        if (tipoGracia.Mes === mesActual){  
          diasGracia = tipoGracia.DiasGracia;
        }
      });

      if (diasGracia === null){
        diasGracia = diasGraciaDefault;            
      }
    }
    return diasGracia;
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0402');

    if (validarStringConAnchoMinimo(this.state.reservaId, 1)){
      global_axios({
        method: 'DELETE',
        url: '/reservasstock/' + this.state.reservaId
      });
    }
  }
    
  procesarConsultaPedidos(){
    Promise.all([
      this.consultarPedidosMovilesPendProforma(),
      this.consultarPedidosPorDevolucion(),
      this.consultarPedidosMovilesNuevos()
    ])
    .then(([pedidosMoviles, pedidosPorDevolucion, pedidosMovilesNuevos]) => {
        this.setState({ pedidosPendientesProforma: pedidosMoviles.concat(pedidosPorDevolucion), pedidosMovilesNuevos });
    })
    .catch(error=>{
      alert(`Ocurrió un error al consultar pedidos. Error: ${error}`);
    });
  }

  procesarConsultaProfPendFacturar(){
    this.props.cargar_Proformas('PendientesFacturar')
    .then(()=>this.setState({proformasPendFactura: this.props.proformas.map(proformaPorFacturar => proformaPorFacturar)}));
  }

  getOptions_Clientes(input, callback){
    if (input.toString().length >= 3 ){
      let query = '?tipo=catalogo&cadena_busq=' + input;     
      cargarCatalogosGenericoAsync('/clientes', query, callback)
    }
  }
  
  getOptions_Vendedores(input, callback){
    if (input.toString().length >= 3 ){
      let query = '?tipo=catalogo&cadena_busq=' + input;     
      cargarCatalogosGenericoAsync('/vendedores', query, callback)
    }
  }

  cambiarEstadoPedidoMovil(estado){
    // Estado-> puede tener 'B' que es bloqueado o 'I' que es impreso.
    // Se procede a llamar el metodo que cambia el estodo del pedido Inalambrik
    if(this.state.pedidoSeleccionado.Pedido!==null && this.state.pedidoSeleccionado.Pedido!== '' && this.state.pedidoSeleccionado.Pedido!==undefined && this.state.operacion==='G' && this.state.tipoPedidoMovilSeleccionado==='PM')
    {
      this.props.cambiar_VisualizacionLoading(true);
      global_axios({
        method: 'POST',
        url: `/pedidosmoviles/actualizaestado/${this.state.pedidoSeleccionado.Pedido}/${estado}/${getItemDatosSesion('usuario').toString()}`
      })
      .then(()=>this.props.cambiar_VisualizacionLoading(false))
      .catch((error)=> {
        this.props.cambiar_VisualizacionLoading(false);
        alert(error.response?error.response.data.msg:error.message);
      });
    }
  }

  importarPedido(idPedido, tipo, callback){
    
    let configRequest = { method: 'GET', url: (tipo==='PM'?'/pedidosmoviles/':'/pedidospordevolucion/') + idPedido };
    let porPlazo=0

    this.props.cambiar_VisualizacionLoading(true);

    var fechaProceso = getFechaProcesoPorModulo('04');
    /* Se consulta el pedido móvil o pedido de devolución y su detalle de artículos */
    global_axios(configRequest)
    .then((response)=> {
      let data_pedido = response.data;
      
      let puedeContinuar=true;
      if(data_pedido.cli.Status==='P')
      { // Se verifica que el cliente no este en estado Pasivo.
        alert('El cliente posee un estado de Pasivo, no se puede continuar')
        this.props.cambiar_VisualizacionLoading(false);
        return;
      }
      if (data_pedido.Status==='I' || data_pedido.Status==='B'){
        if(data_pedido.UsuarioPProf !=='' && data_pedido.UsuarioPProf!==null && data_pedido.UsuarioPProf!==undefined){
          if(data_pedido.UsuarioPProf !== getItemDatosSesion('usuario').toString() )
          {
            alert('El pedido seleccionado se encuentra bloqueado.');
            puedeContinuar=false;
          }
        }
        if(puedeContinuar)
        {
          let emailValido = esEmailValido(data_pedido.cli.Email);
          if (emailValido===false){
            this.props.cambiar_VisualizacionLoading(false);
            alert('El cliente: ' + data_pedido.Cliente + ' no tiene un email registrado. Favor proceda a registrar el email correspondiente.');          
          }else{
            this.setState({ pedidoSeleccionado: data_pedido, tipoPedidoMovilSeleccionado: tipo},()=>this.cambiarEstadoPedidoMovil('B'));

            /* Variable tipo: permite identificar un pedido movil (PM) o pedido de devolucion (PD) */
          
            /* Se inicializa los datos de cabecera de la proforma con los datos del pedido */
            if (data_pedido.PorDescuentoPlazo===null || data_pedido.PorDescuentoPlazo===undefined){
              porPlazo=(tipo==='PM'?this.state.pedidoSeleccionado.tb.ValorCuenta1:0)
            }
            else
            {
              porPlazo=data_pedido.PorDescuentoPlazo
              
            }
            this.setState({
              cliente_sel: generarItemCatalogoSeleccionado(this.state.pedidoSeleccionado.Cliente, this.state.pedidoSeleccionado.cli.Nombre),
              vendedor_sel: generarItemCatalogoSeleccionado(this.state.pedidoSeleccionado.Vendedor, this.state.pedidoSeleccionado.vend.Nombre),
              tipoCliente_sel: this.state.pedidoSeleccionado.cli.Tipo,
              //terminoPago_sel: (tipo==='PM'?this.state.pedidoSeleccionado.TerminoPago.trim():null),
              terminoPago_sel: (this.state.pedidoSeleccionado.TerminoPago.trim()),
              Devolucion: (tipo==='PD'?this.state.pedidoSeleccionado.Devolucion:null),
              porcentajeDsctoPlazo:porPlazo//(tipo==='PM'?this.state.pedidoSeleccionado.tb.ValorCuenta1:0)
              ,habilitarTerPago:false
            });

            // Proceso para consultar si un cliente tiene descuentos habilitados:
            global_axios({
              method: 'GET',
              url: `/clientes/${this.state.pedidoSeleccionado.Cliente}/descuentos?fechaExpiracion=${fechaProceso}`
            })
            .then((response)=> {
              this.setState({descuentosCliente: response.data});
            })
            .catch((error)=> {
              alert(error.response?error.response.data.msg:error.message);
            });

            this.generarDireccionesCliente(this.state.pedidoSeleccionado.cli);

            if (this.state.pedidoSeleccionado.idDireccion !== null){
                if (this.state.pedidoSeleccionado.idDireccion>0){
                  this.setState({ direccion_sel: this.state.pedidoSeleccionado.idDireccion});
                }
            }

            let nroItemsPedido = this.state.pedidoSeleccionado.detalle_ped.length;

            /* La cantidad que se toma de cada item del pedido corresponde al saldo por despachar: (Cantidad - Despachado) */
            
            let dataInputReserva = {  pedidoMovil: tipo==='PM'?this.state.pedidoSeleccionado.Pedido:null,
                                      pedidoPorDevol: tipo==='PD'?this.state.pedidoSeleccionado.Pedido:null,
                                      tipoCliente: this.state.tipoCliente_sel, idPtoFacturacion: this.props.puntoFacturacionSel,
                                      fechaReserva: fechaProceso,
                                      articulos: [], tipoReserva: 'RESERVAR' };
            
            for(let i=0; i<nroItemsPedido; i++){
              let itemPedido = this.state.pedidoSeleccionado.detalle_ped[i];
              if (itemPedido.Status.toString().trim() ==='A'){
                let cantidad = parseFloat(itemPedido.Cantidad) + parseFloat((itemPedido.BackOrder===null)?0:itemPedido.BackOrder) - parseFloat((itemPedido.Despachado===null)?0:itemPedido.Despachado);
                dataInputReserva.articulos.push({Articulo: itemPedido.Articulo, Cantidad: cantidad});
              }
            }

            /* Se procesa la reserva de stock de los artículos seleccionados */
            global_axios({
              method: 'POST',
              url: '/reservasstock',
              data: dataInputReserva
            })
            .then((response)=> {
              let detalleReserva = response.data;

              let itemsProforma = [];
              detalleReserva.forEach((itemReserva, indice)=>{
                  /* Se guarda el Id de la reserva que se genere */
                  if (indice===0){
                    this.setState({reservaId: itemReserva.Reserva});
                  }

                  /* Se genera cada item de la proforma con los datos del pedido, stock y reserva generada */
                  itemsProforma.push({
                    EsPromocion: '',
                    NroItem: completar_String((indice + 1).toString(), '0', 3),
                    Articulo: itemReserva.Articulo,
                    Descripcion: itemReserva.NombreArticulo,
                    CantPedido: itemReserva.CantPedido,
                    CantPorDespachar: itemReserva.CantPedido,
                    StockPrincipal: itemReserva.StockPrincipal,
                    StockAlterno: itemReserva.StockAlterno,
                    StockTransito: itemReserva.CantEnTransito,
                    CantidadDespacho: itemReserva.CantReservaTotal,
                    ReservaPrinc: itemReserva.CantReservaPrinc===null?0:itemReserva.CantReservaPrinc,
                    ReservaAlt: itemReserva.CantReservaAlt===null?0:itemReserva.CantReservaAlt,
                    ReservaTransito: itemReserva.CantReservaTrans===null?0:itemReserva.CantReservaTrans,
                    PrecioUnit: itemReserva.PrecioUnit,
                    CostoPromedio: itemReserva.CostoPromedio,
                    GravaIva: itemReserva.GravaIva,
                    Descuento: itemReserva.Descuento,
                    DescuentoOrig: itemReserva.Descuento,
                    EsEditable: true,
                    Sublinea: itemReserva.Sublinea,
                    TipoCompra: itemReserva.TipoCompra,
                    SecReserva: itemReserva.Secuencia,
                    CantidadLiberada: null,
                    ImportacionXLiberar: null,
                    MotivoCambio: null,
                    CantidadDespachoOrig: itemReserva.CantReservaTotal,
                    VendidoOriginal: itemReserva.CantReservaTotal
                  });
              });

              this.setState({ detalleProforma: itemsProforma, existenCambiosEnDetalle: true }, ()=>{
                this.aplicarDescuentosPorCliente(this.state.pedidoSeleccionado.Cliente, this.state.formaPago_sel);
              });

              if (callback && typeof(callback) === 'function') {
                callback();
              }
              this.props.cambiar_VisualizacionLoading(false);
            })
            .catch((error)=> {        
              this.props.cambiar_VisualizacionLoading(false);
              alert(error.response?error.response.data.msg:error.message);
            });      
          }
        }
        
      }else{
        this.props.cambiar_VisualizacionLoading(false);
        alert('El pedido seleccionado no tiene el estado necesario para ser procesado.');
      }
    })
    .catch((error)=> {
      this.props.cambiar_VisualizacionLoading(false);
      alert(error.response?error.response.data.msg:error.message);      
    });     
  }

  consultarPromocionesVigentes(fechaActual){
    this.setState({itemsPromocion: []});

    global_axios({
      method: 'GET',
      url: `/promociones?fechaActual=${fechaActual}`,
    })
    .then((response)=> {
      try {
        let promocionesVigentes = response.data;
        
        if(promocionesVigentes.length>0){
          let promocion = promocionesVigentes[0];

          if(promocion.Tipo === 'LINEA' || promocion.Tipo === 'LIFAC'){
            promocion.detPromo.forEach(linea => {
              this.consultarArticulosEnPromocion(promocion.Tipo, linea.tipoCompra.Codigo);
            });

          }else{
            if(promocion.Tipo === 'LIART'){

              promocion.artsPromo.forEach(item=>{
                let itemPromocion = {
                  NroItem: this.state.itemsPromocion.length + 1,
                  Articulo: item.Articulo,
                  Descripcion: item.Nombre,
                  Marca: `${item.CodMarca} - ${item.DescripMarca}`,
                  TipoCompra: `${item.CodTipoCompra} - ${item.DescripTipoCompra}`,
                  Precio: item.Precio,
                  Stock: item.SaldoStock
                }
              
                this.setState({ itemsPromocion: this.immutablePush(this.state.itemsPromocion, itemPromocion) });              
              });              
            }
          }
        }

        this.setState({promocionesVigentes});

      }catch(error){
        alert(`Ocurrió un error al realizar la consulta/carga de promociones existentes. Error: ${error}`);
      }
    })
    .catch((error)=> {
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  consultarArticulosEnPromocion(tipoPromo, tipoCompra){
    global_axios({
      method: 'GET',
      url: `/articulos?tipo=articulosystock&tipocompra=${tipoCompra};`
    })
    .then((response)=> {
        try {
          response.data.forEach((item) =>{
            let itemPromocion = {
              NroItem: this.state.itemsPromocion.length + 1,
              Articulo: item.Articulo,
              Descripcion: item.Nombre,
              Marca: `${item.CodMarca} - ${item.DescripMarca}`,
              TipoCompra: `${item.CodTipoCompra} - ${item.DescripTipoCompra}`,
              Precio: item.Precio,
              Stock: item.SaldoStock
            }

            if (tipoPromo === 'LIFAC'){
              this.state.detalleProforma.forEach(itemProf=>{
                if (itemProf.Articulo === itemPromocion.Articulo && itemProf.EsPromocion !== '*'){
                  this.setState({ itemsPromocion: this.immutablePush(this.state.itemsPromocion, itemPromocion) });
                }
              });
            }else{
              if (tipoPromo === 'LINEA'){
                this.setState({ itemsPromocion: this.immutablePush(this.state.itemsPromocion, itemPromocion) });
              }
            }
          });
        } catch (error) {
          alert(`Ocurrió un error al consultar artículos en promoción: ${error}`);
        }
    })
    .catch((error)=> {      
      alert(error.response?error.response.data.msg:error.message);
    });
  }
  
  consultarPedidosMovilesPendProforma(){
    return new Promise((resolve, reject) => {
      global_axios({
        method: 'GET',
        url: '/pedidosmoviles?estado=I&limit=500&usuario='+getItemDatosSesion('usuario').toString(),
      })
      .then((response)=> {
        let data_pedidos = response.data;
        let pedidosVisualizar=[];

        data_pedidos.forEach((pedido, i)=> {
          pedido.NroItem= completar_String((i+1).toString(), '0', 3);
          pedido.Cliente = pedido.Cliente + ' - ' + pedido.NombreCliente;        
          pedido.Items = parseFloat(pedido.Items);
          pedido.ItemsPend = parseFloat(pedido.Items) - parseFloat(pedido.ItemsDespachados);
          pedido.Fecha = pedido.FechaPedido + ' ' + pedido.HoraPedido;
          pedido.Devolucion = '';
          
          pedidosVisualizar.push(pedido);
        });
        
        resolve(pedidosVisualizar);
      })
      .catch((error)=> {
        reject(error.response?error.response.data.msg:error.message);
      });
    });
  }

  consultarPedidosMovilesNuevos(){
    return new Promise((resolve, reject) => {
      global_axios({
        method: 'GET',
        url: '/pedidosmoviles?estado=A&limit=500',
      })
      .then((response)=> {
        let pedidosMovilesNuevos = response.data;
        let _pedidosMovilesNuevos = [];

        pedidosMovilesNuevos.forEach((pedido, i)=> {
          _pedidosMovilesNuevos.push({
            NroItem: completar_String((i+1).toString(), '0', 3),
            Pedido: pedido.Pedido,
            Cliente: `${pedido.Cliente} - ${pedido.NombreCliente}`,
            FechaPed: `${pedido.FechaPedido} ${pedido.HoraPedido}`,
            FechaIngSist: `${pedido.FechaIngSist} ${pedido.HoraIngSist}`,
            Total: parseFloat(pedido.Total),
            Items: parseFloat(pedido.Items),
            Vendedor: `${pedido.Vendedor} - ${pedido.NombreVendedor}`,
            Estado: pedido.Estado
          });
        });
        
        resolve(_pedidosMovilesNuevos);
      })
      .catch((error)=> {
        reject(error.response?error.response.data.msg:error.message);
      });
    });
  }
  
  consultarPedidosPorDevolucion(){
    return new Promise((resolve, reject) => {
      global_axios({
        method: 'GET',
        url: '/pedidospordevolucion?estado=I&limit=500',
      })
      .then((response)=> {      
        let data_pedidos = response.data;
        let pedidosVisualizar=[];

        data_pedidos.forEach((pedido, i)=> {
          pedido.NroItem= completar_String((i+1).toString(), '0', 3);
          pedido.Cliente = pedido.Cliente + ' - ' + pedido.NombreCliente;
          pedido.Items = parseFloat(pedido.Items);
          pedido.ItemsPend = parseFloat(pedido.Items) - parseFloat(pedido.ItemsDespachados);
          pedido.Fecha = pedido.FechaPedido + ' ' + pedido.HoraPedido;
          
          pedidosVisualizar.push(pedido);
        });        
        
        resolve(pedidosVisualizar);
      })
      .catch((error)=> {
        reject(error.response?error.response.data.msg:error.message);
      });
    });
  }

  cambiarVisualizacionModalProfPendFact(){
    if (this.state.esProformaServicio){
      alert('Ud. está realizando una proforma de servicios. No puede importar proformas por facturar.')
      return;
    }

    if (this.state.isVisibleModalProfPendFact===false){
      this.procesarConsultaProfPendFacturar();
    }

    this.limpiar(()=>this.setState({ isVisibleModalProfPendFact: true}));

  }

  limpiar(callback){
    if (validarStringConAnchoMinimo(this.state.reservaId, 1) && this.state.existenCambiosEnDetalle){
        if(window.confirm('Ud. ha hecho cambios en los artículos de la proforma que no han sido guardados. ¿Desea deshacerlos?')){
            this.props.cambiar_VisualizacionLoading(true);
            global_axios({
                method: 'DELETE',
                url: '/reservasstock/' + this.state.reservaId
            })
            .then(()=>this.props.cambiar_VisualizacionLoading(false))
            .catch((error)=>{
                this.props.cambiar_VisualizacionLoading(false);
                alert(error.response?error.response.data.msg:error.message);
            });
        }else {
            return;
        }
    }

    let fechaProceso = getFechaProcesoPorModulo('04');
    if(!this.state.esBotonGuardarMod){
      this.cambiarEstadoPedidoMovil('I');
    }

    this.setState({
      habilitarTerPago:true,
      tipoPedidoMovilSeleccionado: '',
      existenCambiosEnDetalle: false,
      proformaId: '',
      operacion: 'G',
      fechaProforma: moment(fechaProceso, 'DD/MM/YYYY'),
      formaPago_sel: 'CR',
      tipoCliente_sel: null,
      cliente_sel: null,
      vendedor_sel: null,
      articulo_sel: null,
      reservaId: '',
      descuento: '',
      estadoActual: 'P',
      terminoPago_sel: null,
      pedidoSeleccionado: {},
      detalleProforma: [],
      cantidadArt: '',
      precioUnitArt: '',
      descripcionArt: '',
      proformaCopiadaId: '',
      Devolucion: null,
      subtotalConIva: parseFloat(0.00),
      subtotalSinIva: parseFloat(0.00),
      total: parseFloat(0.00),
      valorIva: parseFloat(0.00),
      totalDscto: parseFloat(0.00),
      totalDsctoLinea: parseFloat(0.00),
      cabeceraEsModificable: true,
      detalleEsModificable: true,
      direccionesCliente: [],
      direccion_sel: 0,
      esProformaServicio: false,
      embalaje: null,
      proformasPendFactura: [],
      idFactura: null,
      descuentosCliente: [],
      dsctoClienteId: null,
      promocionesVigentes: [],
      isVisibleModalPromociones: false,
      itemsPromocion: [],
      nroFactura: '',
      descripTipoProformaProd: '',
      tipoProforma: '',
      proformasPendFact: [],
      esDetallePendiente: false,
      esCopiada: null,
      esBotonGuardarMod: false,
      porcentajeDsctoPlazo: 0,
      totalDsctoPlazo: 0,
      encartonadoId: '',
      articulosEliminados: []
    });

    this.state.gridDetProformaColumnApi.setColumnVisible('MotivoCambio', false);

    Promise.all([
      obtenerParametros('DIASGRACIA'),
      obtenerParametros('IVAACTUAL'),
      obtenerParametros('CAJAGENERAL'),
      obtenerParametros('PORCDESCUENTO'),
      obtenerSecuencial('Pedido')
    ])
    .then(([paramsDiasGracia, paramIvaActual, paramCajaGen, paramPorcDscto, secuencialProforma]) => {
      this.setState(
        { diasGracia: this.generarDiasGracia(paramsDiasGracia),
          porcentIva: parseFloat(paramIvaActual[0].IvaActual),
          cajaGen: paramCajaGen[0].CajaGeneral,
          paramPorcentajeDscto: parseFloat(paramPorcDscto[0].PorcDescuento),
          porcentajeDscto: parseFloat(paramPorcDscto[0].PorcDescuento),
          secuencialProforma: completar_String((secuencialProforma.codigo - 1).toString(), '0', 6)
        });

      this.consultarPromocionesVigentes(fechaProceso);
    })
    .catch(error =>
      alert('Se produjo un error al consultar el código de la última Proforma generada: ' + error)
    );

    if (callback && typeof(callback) === 'function') {
      callback();
    }
  }
  
  handleAddArticulo(){
    // Validacion de permisos.

    if (this.state.operacion==='G' && !this.state.permitirGeneracionProforma) {
      alert(msgErrorPermisoGeneracionProforma);
      return;
    }

    if (this.state.operacion==='M' && !this.state.permitirModifDetProformaAgregar) {
      alert(msgErrorPermisoModifDetalleProforma + ' No puede añadir artículos.');
      return;
    }

    if (this.state.operacion==='G' || (this.state.operacion==='M' && this.state.detalleEsModificable===true)){

        if (this.state.cliente_sel===null || this.state.cliente_sel===undefined){
            alert('Ud. no ha seleccionado el cliente al que le generará la proforma.');
        }else if (!validarCampoString(this.state.tipoCliente_sel, 1)){
            alert('Ud. no ha seleccionado el tipo de cliente al que le generará la proforma.');
        }else if (this.state.articulo_sel===undefined || this.state.articulo_sel===null){
            alert('Ud. no ha seleccionado el artículo que desea añadir.');
        }else if (!esNumero(this.state.cantidadArt)){
            alert('Ud. no ha indicado la cantidad del artículo que desea añadir.');
        }else if ( this.state.operacion === 'M' && (formatearNumeroEntero(this.state.detalleProforma.length) >= formatearNumeroEntero(this.state.nroItemsPorProforma))){
            alert('No se puede agregar más artículos a la proforma. El numéro máximo de items es de: ' + this.state.nroItemsPorProforma.toString())
        } else {
            const precioUnit = this.state.precioUnitArt;
            const descripcion = this.state.descripcionArt;

            if (this.state.esProformaServicio){
              if (!validarCampoString(descripcion, 1, 80)){
                alert('Ud. no ha especificado correctamente la descripción del artículo que desea añadir.');
                return;
              }
              if (Number.isNaN(precioUnit)){
                alert('Ud. no ha indicado el precio unitario del artículo que desea añadir.');
                return;
              }
              if ( parseFloat(precioUnit)<=0 ) {
                alert('El precio unitario que ha especificado es inválido.');
                return;
              }
            }

            const articulo = this.state.articulo_sel;
            const cantidad = this.state.cantidadArt;

            if ( !(Number.isInteger(Number(cantidad))) || formatearNumeroEntero(cantidad)<=0 ) {
              alert('La cantidad que desea añadir es inválida.');
            }else{
              let existe_articulo = false;

              for(let i=0; i<this.state.detalleProforma.length; i++ ){
                let item = this.state.detalleProforma[i];
                if (articulo.value === item.Articulo){
                  existe_articulo = true;
                  break;
                }
              }

              if (existe_articulo){
                alert(`El artículo: ${articulo.value} ya existe en la proforma y no se puede añadir otra vez.`);
              }else{
                this.insertarArticuloEnProforma(articulo.value, cantidad, 'VENDIDO');
              }
            }
        }
    }else{
      alert(msgErrorProformaNoModificable);
    }
  }

  insertarArticuloEnProforma(articulo, cantidad, tipoItem){
    try {
      this.props.cargar_Articulo(articulo)
      .then(()=>{
          let articuloSel = this.props.articulo;

          if (!validarJSON(articuloSel)){
            alert('El artículo seleccionado no existe.');
            return;
          }

          if (articuloSel.estado === 'I'){
            alert('El artículo seleccionado tiene estado: INACTIVO. No puede ser añadido a la proforma.');
            return;
          }

          if (articuloSel.sublinea1 === 'SX'){
            alert('El artículo seleccionado no puede ser añadido manualmente a una proforma.');
            return;
          }

          let fechaProceso = getFechaProcesoPorModulo('04');

          /*Se genera la reserva del artículo que se está añadiendo */
          let pedidoMovil = this.state.pedidoSeleccionado.Pedido? this.state.pedidoSeleccionado.Pedido: null;
          let url = (this.state.reservaId===undefined || this.state.reservaId==='')?'/reservasstock':('/reservasstock/' + this.state.reservaId + '/itemsreserva');
          let art = {Articulo: articulo, Cantidad: cantidad};
          let data = (this.state.reservaId===undefined || this.state.reservaId==='')?
                    { pedidoMovil, pedidoPorDevol: null, tipoCliente: this.state.tipoCliente_sel, idPtoFacturacion: this.props.puntoFacturacionSel, articulos: [art], fechaReserva: fechaProceso }
                    :{ operacion: this.state.operacion, articulo: art, fechaReserva: fechaProceso };
          
          global_axios({
            method: 'POST',
            url,
            data
          })
          .then((response)=> {
            let itemReserva = response.data[0];
            
            if (parseFloat(itemReserva.CantReservaTotal)>0){
              
              if (this.state.detalleProforma.length === 0){
                this.setState({ reservaId: itemReserva.Reserva });
              }

              let precioUnit = tipoItem==='PROMOCION'?0:(this.state.esProformaServicio?parseFloat(this.state.precioUnitArt):itemReserva.PrecioUnit);
            
              let itemProforma = {
                EsPromocion: tipoItem==='PROMOCION'?'*':'',
                NroItem: completar_String((this.state.detalleProforma.length + 1).toString(), '0', 3),
                Articulo: itemReserva.Articulo,
                Descripcion: this.state.esProformaServicio?this.state.descripcionArt.toUpperCase().trim():itemReserva.NombreArticulo,
                CantPedido: itemReserva.CantPedido,
                CantPorDespachar: itemReserva.CantPedido,
                StockPrincipal: itemReserva.StockPrincipal,
                StockAlterno: itemReserva.StockAlterno,
                StockTransito: itemReserva.CantEnTransito,
                CantidadDespacho: itemReserva.CantReservaTotal,
                ReservaPrinc: itemReserva.CantReservaPrinc===null?0:itemReserva.CantReservaPrinc,
                ReservaAlt: itemReserva.CantReservaAlt===null?0:itemReserva.CantReservaAlt,
                ReservaTransito: itemReserva.CantReservaTrans===null?0:itemReserva.CantReservaTrans,
                PrecioUnit: precioUnit,
                CostoPromedio: itemReserva.CostoPromedio,
                GravaIva: itemReserva.GravaIva,
                Descuento: itemReserva.Descuento,
                DescuentoOrig: itemReserva.Descuento,
                EsEditable: tipoItem!=='PROMOCION',
                Sublinea: itemReserva.Sublinea,
                TipoCompra: itemReserva.TipoCompra,
                SecReserva: itemReserva.Secuencia,
                CantidadLiberada: null,
                ImportacionXLiberar: this.state.tipoProforma==='T'?0:null,
                MotivoCambio: null,
                CantidadDespachoOrig: 0,
                VendidoOriginal: itemReserva.CantReservaTotal
              };
              this.setState({ detalleProforma: this.immutablePush(this.state.detalleProforma, itemProforma),
                                    // Control de cambios en el grid de detalle.
                                    existenCambiosEnDetalle: true}, () => {
                this.aplicarDescuentosPorCliente(this.state.cliente_sel.value, this.state.formaPago_sel);
              });
            }else{
              let msgErrorSinExistencias = `No existe stock disponible para el artículo: ${articulo}.`;
              if(this.state.operacion === 'M') {
                  msgErrorSinExistencias += ' Al modificar una proforma no se considera el stock  en tránsito de un artículo.';
              }
              alert(msgErrorSinExistencias);
            }
          })
          .catch((error)=> {
            alert(error.response?error.response.data.msg:error.message);      
          });
      });
    } catch(error){
      alert(`Se produjo un error al insertar artículo en la proforma. Error:  ${error}`);
    }
  }

  quitarArticuloDeProforma(itemProf){
    return new Promise((resolve, reject)=>{
      let indiceEliminar;
      let reservaId = this.state.reservaId;

      for(indiceEliminar=0; indiceEliminar<this.state.detalleProforma.length; indiceEliminar++){
        if (this.state.detalleProforma[indiceEliminar].NroItem === itemProf.NroItem){
          break;
        }
      }

      let fechaProceso = getFechaProcesoPorModulo('04');

      let axios_config = {
        method: 'DELETE',
        url: `/reservasstock/${reservaId}/itemsreserva/${itemProf.SecReserva}`,
        headers: {'operacion': `${this.state.operacion}-${this.state.tipoProforma===''?'A':this.state.tipoProforma}`},
        data: {fechaReserva: fechaProceso}
      }

      global_axios(axios_config)
      .then(()=> {
        const newState = {  detalleProforma: this.deleteItemArray(this.state.detalleProforma, indiceEliminar),
                            articulosEliminados: this.state.articulosEliminados.concat({Articulo: itemProf.Articulo, MotivoCambio: itemProf.MotivoCambio})};

        if ((this.state.detalleProforma.length-1)>0){
          this.setState(newState);
        }else{
          this.setState({...newState,
                         reservaId: undefined});
        }
        resolve(`Eliminación de artículo: ${itemProf.Articulo.trim()} se realizó correctamente.`);
      })
      .catch((error)=> {
        reject(error.response?error.response.data.msg:error.message);
      });
    });
  }

  immutablePush(array, newItem){
    return [ ...array, newItem ];
  }

  deleteItemArray (arr, index) {
    let indice = formatearNumeroEntero(index);
    let arr_tmp = arr.slice(0, indice).concat(arr.slice(indice+1));
    arr_tmp.forEach((item, i)=>{
      item.NroItem = completar_String((i + 1).toString(), '0', 3);
    });
    return arr_tmp;
  }

  handleDeleteArticulo(){
    // Validacion de permisos.

    if (this.state.operacion==='G' && !this.state.permitirGeneracionProforma) {
      alert(msgErrorPermisoGeneracionProforma);
      return;
    }
    if (this.state.operacion==='M' && !this.state.permitirModifDetProformaEliminar) {
      alert(msgErrorPermisoModifDetalleProforma + ' No puede eliminar artículos.');
      return;
    }

    if (this.state.operacion==='G' || (this.state.operacion==='M' && this.state.detalleEsModificable===true)){
        let filasSeleccionadas = this.state.gridDetProformaApi.getSelectedRows();

        if (this.state.detalleProforma.length===0){
            alert('No existen artículos en la proforma.');
            return;
        }

        if (filasSeleccionadas[0]===undefined){
            alert('Debe seleccionar el artículo que desee eliminar.')
            return;
        }

        let itemProforma = filasSeleccionadas[0];

        if ((!itemProforma.EsEditable) && itemProforma.EsPromocion!=='*'){
            this.state.gridDetProformaApi.stopEditing(true);
            alert('La eliminación de este artículo no está permitida.');
            return;
        }

        if (this.state.operacion==='M' && this.state.detalleProforma.length===1){
            alert('No puede eliminar este item puesto que la proforma no puede quedar sin artículos, lo que procede es anularla.');
            return;
        }

        let motivoCambio = itemProforma.MotivoCambio;
        let mensajeConfirmacion = `¿Está seguro de eliminar el artículo: ${itemProforma.Articulo.trim()}?`;

        if(this.state.operacion === 'M') {
            if(this.validarMotivoCambioVacio(motivoCambio)) {
                alert('Debe ingresar el Motivo Cambio por el cual desea eliminar este artículo. Utilice la columna Motivo Cambio del grid.');
                return;
            } else {
                mensajeConfirmacion += ` Con el Motivo Cambio: ${motivoCambio}`;
            }
        }

        let eliminar = window.confirm(mensajeConfirmacion);
        if (eliminar){

          this.quitarArticuloDeProforma(itemProforma)
          // Se controla si existen cambios en el grid de detalle.
          .then(() => this.setState({existenCambiosEnDetalle: true}))
          .catch(error=>{
            alert(`Ocurrió un error al quitar el artículo: ${itemProforma.Articulo}. Error: ${error}`);
          });
        }
    }else{
        alert(msgErrorProformaNoModificable);
    }
  }
  
  actualizarReservaArticulo(eventData){
    if (this.state.operacion==='G' || (this.state.operacion==='M' && this.state.detalleEsModificable===true)){
      let valorNuevo = eventData.valorNuevo;
      let valorAnterior = eventData.valorAnterior;
      let itemProforma = eventData.itemProforma;
      let fechaProceso = getFechaProcesoPorModulo('04');
      
      if (valorNuevo===0){
        alert('La cantidad que ingresó es incorrecta.');
        return;
      }else{
        if (valorNuevo===itemProforma.CantidadDespacho){
          return;
        }else{
          let tipo;
          if (formatearNumeroEntero(valorNuevo)>formatearNumeroEntero(valorAnterior)){
            tipo = 'SUMA';
          }else{
            tipo = 'RESTA';
          }

          global_axios({
            method: 'PUT',
            url: '/reservasstock/' + this.state.reservaId + '/itemsreserva/' + itemProforma.SecReserva,
            data: { operacion: this.state.operacion, tipo, articulo: { Articulo: itemProforma.Articulo, Cantidad: itemProforma.CantPorDespachar },
                    fechaReserva: fechaProceso}
          })
          .then((response)=> {
            let itemReserva = response.data[0];
            let detalleProforma = [];

            this.state.detalleProforma.forEach((item)=>{
              if (item.NroItem === itemProforma.NroItem){
                item = {...item,
                  CantPorDespachar: valorNuevo,
                  StockPrincipal: itemReserva.StockPrincipal,
                  StockAlterno: itemReserva.StockAlterno,
                  StockTransito: itemReserva.CantEnTransito,
                  CantidadDespacho: itemReserva.CantReservaTotal,
                  ReservaPrinc: itemReserva.CantReservaPrinc===null?0:itemReserva.CantReservaPrinc,
                  ReservaAlt: itemReserva.CantReservaAlt===null?0:itemReserva.CantReservaAlt,
                  ReservaTransito: itemReserva.CantReservaTrans===null?0:itemReserva.CantReservaTrans,
                  CostoPromedio: itemReserva.CostoPromedio,
                  Descuento: itemReserva.Descuento,
                  GravaIva: itemReserva.GravaIva,
                  VendidoOriginal: this.state.permitirModifDetProformaCambiar?itemReserva.CantReservaTotal:itemProforma.VendidoOriginal
                }
              }

              detalleProforma.push(item);
            });

            this.setState({ detalleProforma }, () => {
              this.aplicarDescuentosPorCliente(this.state.cliente_sel.value, this.state.formaPago_sel);
            });

            this.state.gridDetProformaApi.refreshCells();
            this.calculoTotales();
          })
          .catch((error)=> {
            alert(error.response?error.response.data.msg:error.message);
          });
        }
      }
    }else{
        alert(msgErrorProformaNoModificable);
    }
  }

  getClientebyId(){
    if (this.state.cliente_sel!==undefined && this.state.cliente_sel!==null){
      let codCliente = this.state.cliente_sel.value;
      let fechaProceso = getFechaProcesoPorModulo('04');
      global_axios({
        method: 'GET',
        url: `/clientes/${codCliente}`
      })
      .then((response)=> {
        let cliente = response.data;
        // Se valida que el status del cliente no sea pasivo.
        if(cliente.status_cli==='P')
        {
          alert('El cliente posee el estado de Pasivo, no se puede continuar...')
          return;
        }
        let emailValido = esEmailValido(cliente.email_representante);
        if (emailValido===false){
          alert('El cliente seleccionado: ' + codCliente + ' no tiene un email registrado. Favor proceda a registrar el email correspondiente.');
          this.setState({ cliente_sel: null });
        }else{

          this.setState({ tipoCliente_sel: cliente.tipo, vendedor_sel: generarItemCatalogoSeleccionado(cliente.vendedor.value, cliente.vendedor.label)});
          this.generarDireccionesCliente(cliente);
                        
          // Proceso para consultar si un cliente tiene descuentos habilitados:
          global_axios({
            method: 'GET',
            url: `/clientes/${codCliente}/descuentos?fechaExpiracion=${fechaProceso}`
          })
          .then((response)=> {
            this.setState({descuentosCliente: response.data}, ()=>this.aplicarDescuentosPorCliente(codCliente, this.state.formaPago_sel));
          })
          .catch((error)=> {
            alert(error.response?error.response.data.msg:error.message);
          });
        }
      })
      .catch((error)=> {
        alert(error.response?error.response.data.msg:error.message);
      });
    }
  }

  generarDireccionesCliente(cliente, codDireccionSeleccionada=0){
    let direccionesCliente = [{value: 0, label: cliente.direccion_principal}];
    if (cliente.detalle_direcciones!==undefined && cliente.detalle_direcciones!==null){
      cliente.detalle_direcciones.forEach((direccionAlt)=>{
        direccionesCliente.push({value: direccionAlt.secuencia , label: direccionAlt.direccion});
      });
    }
    this.setState({ direccionesCliente, direccion_sel: codDireccionSeleccionada});    
  }

  aplicarDescuentosPorCliente(clienteId, formaPago){
    /* Se verifica que existan descuentos habilitados para el cliente seleccionado */
    if (this.state.descuentosCliente!==null){
      if(this.state.descuentosCliente.length>0){
        
        /* Se selecciona el descuento a aplicar de acuerdo con la forma de pago escogida */
        let dsctoCliente = null;
        for(let i=0; i<this.state.descuentosCliente.length; i++){
          let itemDsctoCliente = this.state.descuentosCliente[i];
          
          if ((itemDsctoCliente.Cliente.trim()===clienteId.trim()) && (itemDsctoCliente.FormaPago.trim()===formaPago.trim())){
            dsctoCliente = itemDsctoCliente;
            break;
          }
        }

        let detalleProforma = [];
        
        /* Si existe un descuento para el cliente y forma de pago escogidos se procede a realizar el calculo respectivo 
          de lo contrario se aplica los descuentos generales */

        if (dsctoCliente!==null){
          /* Tipo de descuento aplicable al Total Neto */
          if (dsctoCliente.TipoDescuento.toUpperCase()==='T'){

            /* Se verifica si se aplica o no el Descuento Linea */
            if (dsctoCliente.EfectoDescuentoLinea==='N'){
              this.state.detalleProforma.forEach(itemProf=>{
                detalleProforma.push({...itemProf, Descuento: 0});
              });
            }else{
              this.state.detalleProforma.forEach(itemProf=>{
                detalleProforma.push({...itemProf, Descuento: itemProf.DescuentoOrig});
              });
            }
            
            /* Se verifica si el descuento al Total Neto debe reemplazar al Descuento Global de todos los clientes o debe sumarse */
            if (dsctoCliente.EfectoDescuentoGeneral==='R'){
              this.setState({ porcentajeDscto: parseFloat(dsctoCliente.PDescuento),
                              dsctoClienteId: dsctoCliente.DescuentoId,
                              detalleProforma
                            });
            }else{
              if (dsctoCliente.EfectoDescuentoGeneral==='A'){
                this.setState({ porcentajeDscto: parseFloat(dsctoCliente.PDescuento) + parseFloat(this.state.paramPorcentajeDscto),
                                dsctoClienteId: dsctoCliente.DescuentoId, detalleProforma});
              }
            }            

          }else{
            /* Aplicación de Descuento Linea*/
            if (dsctoCliente.TipoDescuento.toUpperCase()==='P'){
              /* Aplicación de Descuento Linea a todos los artículos */
              if (dsctoCliente.EfectoDescProducto.toUpperCase()==='T'){
                this.state.detalleProforma.forEach(itemProf=>{                  
                  let porcDsctoProd = parseFloat(itemProf.Descuento===null?0:itemProf.Descuento);
                  if (itemProf.Sublinea!=='SX' && porcDsctoProd<parseFloat(dsctoCliente.PDescuento)){
                    detalleProforma.push({...itemProf, Descuento: parseFloat(dsctoCliente.PDescuento)});
                  }else{
                    detalleProforma.push(itemProf);
                  }
                });
              }else{
                /* Aplicación de Descuento Linea a las lineas (TipoCompra) especificadas */
                this.state.detalleProforma.forEach(itemProf=>{
                  let porcDsctoProd = parseFloat(itemProf.Descuento===null?0:itemProf.Descuento);

                  for(let i=0; i<dsctoCliente.dsctoLineas.length; i++){
                    let dsctoLinea = dsctoCliente.dsctoLineas[i];

                    if(dsctoLinea.TipoCompra===itemProf.TipoCompra){
                      if (porcDsctoProd<parseFloat(dsctoLinea.PDescuento)){
                        porcDsctoProd = dsctoLinea.PDescuento;
                        break;
                      }
                    }
                  }
                  detalleProforma.push({...itemProf, Descuento: porcDsctoProd});
                });
              }
              
              this.setState({ detalleProforma, dsctoClienteId: dsctoCliente.DescuentoId,
                              porcentajeDscto: parseFloat(this.state.paramPorcentajeDscto)});
            }
          }
        }else{
          this.state.detalleProforma.forEach(itemProf=>{
            detalleProforma.push({...itemProf, Descuento: itemProf.DescuentoOrig});
          });

          this.setState({ detalleProforma, dsctoClienteId: null,
                          porcentajeDscto: parseFloat(this.state.paramPorcentajeDscto)});
        }
      }
    }
  }

  calculoTotales(){

    let subtotalConIva = parseFloat(0);
    let subtotalSinIva = parseFloat(0);
    let porcentajeIva = parseFloat(this.state.porcentIva);
    let porcentajeDscto = parseFloat(this.state.porcentajeDscto);
    let valorIva = parseFloat(0);
    let total = parseFloat(0);
    let valorDsctoTotal = parseFloat(0);
    let valorDsctoLinea = parseFloat(0);
    let valorFlete = parseFloat(0);
    let valorDsctoPlazo= parseFloat(0);
    let porcentajedescuentoplazo =parseFloat(0);
    let precUnitDesPlazo =parseFloat(0);
    let precUnitDesPlazoDescontado =parseFloat(0);
    let totalDsctoPlazo=parseFloat(0);
    if (this.state.detalleProforma.length>0){
      this.state.detalleProforma.forEach((item) => {
        let cantidad = parseFloat(Number.isNaN(item.CantidadDespacho)? 0: item.CantidadDespacho);
        let precioUnit = parseFloat(Number.isNaN(item.PrecioUnit)? 0: item.PrecioUnit);
        let porcDescuento = parseFloat(Number.isNaN(item.Descuento)?0: item.Descuento);
        porcentajedescuentoplazo= this.state.esProformaServicio?0:parseFloat(this.state.porcentajeDsctoPlazo).toFixed(2);
        if(item.Articulo.trim()==='EMBA'){
          porcentajedescuentoplazo=0;
        }

        precUnitDesPlazo=parseFloat(multiplicarDecimales(precioUnit, parseFloat(porcentajedescuentoplazo)/100));
        precUnitDesPlazoDescontado= parseFloat(parseFloat(precioUnit)-parseFloat(precUnitDesPlazo));
        valorDsctoPlazo= parseFloat(multiplicarDecimales(cantidad, parseFloat(precUnitDesPlazo))).toFixed(2);
        
        totalDsctoPlazo = parseFloat(parseFloat(totalDsctoPlazo) + parseFloat(valorDsctoPlazo)).toFixed(2);
  
        let precioUnitDscto = parseFloat(multiplicarDecimales(precUnitDesPlazoDescontado, porcDescuento/100));
        let precioUnitDescontado = parseFloat(parseFloat(precUnitDesPlazoDescontado)-parseFloat(precioUnitDscto));
        let subTotalItem = parseFloat(multiplicarDecimales(cantidad, precioUnitDescontado)).toFixed(2);
        let subTotalDsctoItem = parseFloat(multiplicarDecimales(cantidad, precioUnitDscto)).toFixed(2);      

        valorDsctoLinea = parseFloat(parseFloat(valorDsctoLinea) + parseFloat(subTotalDsctoItem)).toFixed(2);
    
        if (item.GravaIva){
          subtotalConIva = parseFloat(parseFloat(subtotalConIva) + parseFloat(subTotalItem)).toFixed(2);
        }else{
          subtotalSinIva = parseFloat(parseFloat(subtotalSinIva) + parseFloat(subTotalItem)).toFixed(2);          
        }

        valorFlete += parseFloat(item.Sublinea==='SX'?subTotalItem:0);
      });

      if (parseFloat(porcentajeDscto)>0){
        valorDsctoTotal = parseFloat(multiplicarDecimales(parseFloat(subtotalConIva) + parseFloat(subtotalSinIva) - parseFloat(valorFlete), porcentajeDscto/100)).toFixed(2);
      }

      if (parseFloat(subtotalConIva) > parseFloat(valorDsctoTotal)){
        subtotalConIva = parseFloat(parseFloat(subtotalConIva)-parseFloat(valorDsctoTotal)).toFixed(2);
      }else{
        subtotalSinIva = parseFloat(parseFloat(subtotalSinIva)-parseFloat(valorDsctoTotal)).toFixed(2);
      }

      valorIva = parseFloat(multiplicarDecimales(subtotalConIva, porcentajeIva/100)).toFixed(2);
      total = parseFloat(parseFloat(subtotalSinIva) + parseFloat(subtotalConIva) + parseFloat(valorIva)).toFixed(2);
    }
    
    this.setState( {  subtotalConIva: parseFloat(subtotalConIva), subtotalSinIva: parseFloat(subtotalSinIva), total: parseFloat(total),
                      totalDscto: parseFloat(valorDsctoTotal), totalDsctoLinea: parseFloat(valorDsctoLinea), valorIva: parseFloat(valorIva), totalDsctoPlazo:totalDsctoPlazo } );
  }

  contarArticulosPorTipoCompraEnProforma(tipoCompra, tipoArticulo){
    let acumCantArticPorTipoCompra = 0;
    this.state.detalleProforma.forEach(itemProf =>{
      if((itemProf.TipoCompra.trim() === tipoCompra.trim()) || tipoCompra === 'Todos' ){
        if (tipoArticulo === 'VENDIDO' && itemProf.EsPromocion === ''){
          acumCantArticPorTipoCompra += itemProf.CantidadDespacho
        }
        if (tipoArticulo === 'PROMOCION' && itemProf.EsPromocion === '*'){
          acumCantArticPorTipoCompra += itemProf.CantidadDespacho
        }
      }
    });
    return acumCantArticPorTipoCompra;
  }

  cambiarVisualizacionModalPromociones(){
    this.setState({isVisibleModalPromociones: !this.state.isVisibleModalPromociones});
  }

  generarItemsPromocionEnProforma(){
    // Se considera que siempre existirá una sola promoción vigente:

    if (this.state.promocionesVigentes.length>0){
      let msgVerificacion = 'El ingreso de promociones es incorrecto:\n';
      let promocionVigente = this.state.promocionesVigentes[0]; 
      let lineasPromocion = promocionVigente.detPromo;
      let validacionOk = true;

      for(let i=0; i<lineasPromocion.length; i++){
        let lineaPromo = lineasPromocion[i];
        let cantArtVendTipoCompra = this.contarArticulosPorTipoCompraEnProforma(lineaPromo.Linea, 'VENDIDO');
        let cantArtPromTipoCompra = 0;
        
        this.state.itemsPromocion.forEach(itemPromo =>{
          
          if(validarCampoString(itemPromo.CantPromocion, 1, 3)){
            if(parseFloat(itemPromo.CantPromocion)>0){
              if(promocionVigente.Tipo === 'LIART'){
                cantArtPromTipoCompra+=parseFloat(itemPromo.CantPromocion);
              }else{
                if(promocionVigente.Tipo === 'LINEA' || promocionVigente.Tipo === 'LIFAC'){
                  if(itemPromo.TipoCompra.substr(0, 2)===lineaPromo.Linea){
                    cantArtPromTipoCompra+=parseFloat(itemPromo.CantPromocion);
                  }
                }
              }
            }
          }
        });

        let cantValidaArtPromo = Math.trunc(cantArtVendTipoCompra/lineaPromo.CantidadBase)*lineaPromo.CantidadRegalo;
        if(cantValidaArtPromo !== cantArtPromTipoCompra){
          msgVerificacion += `Por la linea: ${lineaPromo.tipoCompra.Codigo} - ${lineaPromo.tipoCompra.Descripcion.trim()} debe ingresar ${cantValidaArtPromo} artículos regalados de promoción.\n`;
          validacionOk = false;          
        }
      }

      if (validacionOk===false){
        alert(msgVerificacion);
      }else{
        this.actualizarArticulosPromocion();
      }
    }
  }

  actualizarArticulosPromocion(){
    let itemPromo = null;
    for (let i=0; i<this.state.detalleProforma.length; i++) {
      if (this.state.detalleProforma[i].EsPromocion === '*'){
        itemPromo = this.state.detalleProforma[i];
        break;
      }
    }

    if (itemPromo!==null){
      this.quitarArticuloDeProforma(itemPromo)
      .then(()=>{
        this.actualizarArticulosPromocion();
      })
      .catch(error=>{
        alert(`Ocurrió un error al deshacer el artículo de promoción: ${itemPromo.Articulo}. Error: ${error}`);
      });

    }else{
      this.state.itemsPromocion.forEach(itemPromo =>{
        if(validarCampoString(itemPromo.CantPromocion, 1, 3)){
          if (parseFloat(itemPromo.CantPromocion)>0){
            this.insertarArticuloEnProforma(itemPromo.Articulo, itemPromo.CantPromocion, 'PROMOCION');
          }
        }
      });
      this.cambiarVisualizacionModalPromociones();
    }
  }

  verificarPromocionesAplicadas(){
    let validacionOk = true;
    let msgVerificacion = 'El ingreso de promociones es incorrecto:\n';    
            
    // Se considera que siempre existirá una sola promoción vigente:
    if (this.state.promocionesVigentes.length>0){
      let promocion = this.state.promocionesVigentes[0];
      
      let lineasPromocion = promocion.detPromo;

      for(let i=0; i<lineasPromocion.length; i++){
        let lineaPromo = lineasPromocion[i];
        let cantArtVendTipoCompra = this.contarArticulosPorTipoCompraEnProforma(lineaPromo.Linea, 'VENDIDO');
        let cantArtPromTipoCompra = this.contarArticulosPorTipoCompraEnProforma(lineaPromo.Linea, 'PROMOCION');
        
        if (cantArtVendTipoCompra>=lineaPromo.CantidadBase){
          let cantValidaArtPromo = Math.trunc(cantArtVendTipoCompra/lineaPromo.CantidadBase)*lineaPromo.CantidadRegalo;
          if(cantValidaArtPromo !== cantArtPromTipoCompra){
            msgVerificacion += `Por la linea: ${lineaPromo.tipoCompra.Codigo} - ${lineaPromo.tipoCompra.Descripcion.trim()} en esta factura debe ingresar ${cantValidaArtPromo} artículos.\n`;
            validacionOk = false;
          }
        }
      }

      if(validacionOk===false){
        alert(msgVerificacion);
      }
    }
    return validacionOk;
  }

    /* Retorna true si el MotivoCambio evaluado no ha sido ingresado */
    validarMotivoCambioVacio = (motivoCambio) => {
        return motivoCambio === null || motivoCambio === MOTIVO_CAMBIO_VACIO;
    }


  guardarProforma() {
    // Validacion de permisos.
    if (this.state.operacion === 'G') {
      if (!this.state.permitirGeneracionProforma) {
          alert(msgErrorPermisoGeneracionProforma);
          return;
      }
    }
    if (this.state.operacion === 'M') {
      if (!(this.state.permitirModifCabProforma ||
            this.state.permitirModifDetProformaAgregar ||
            this.state.permitirModifDetProformaEliminar ||
            this.state.permitirModifDetProformaCambiar ||
            this.state.permitirModifDetProformaCambiarLimitado)) {
          alert(msgErrorPermisoModificacionProforma);
          return;
      }
    }

    if (this.state.operacion === 'M' && this.state.cabeceraEsModificable === false && this.state.detalleEsModificable === false ) {
        alert(msgErrorProformaNoModificable);
      return;
    }

    let fechaProforma = formatearFechaMoment_a_String(this.state.fechaProforma);
    if (!validarFechaMomentEnFormatoString(fechaProforma)) {
      alert('La fecha de la Proforma es inválida');
      return;
    }

    let fechaProceso = getFechaProcesoPorModulo('04');

    let proformaId = this.state.proformaId;
    let cliente = this.state.cliente_sel;
    let tipoCliente = this.state.tipoCliente_sel;
    let vendedor = this.state.vendedor_sel;
    let formaPago = this.state.formaPago_sel;
    let terminoPago = this.state.terminoPago_sel;

    if (cliente === null || cliente === undefined) {
      alert('Debe especificar el cliente al que se realiza la proforma.');
      return;
    }

    if (tipoCliente === null || tipoCliente === '') {
      alert('Debe especificar el tipo de cliente al que se realiza la proforma.');
      return;
    }

    if (vendedor === null || vendedor === undefined) {
      alert('Debe especificar el vendedor.');
      return;
    }

    if (this.props.permiteCambioFProceso === 'S') {
      let validFProceso = validarFechaTransaccionSeleccionada(this.state.fechaProforma, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);

      if (!validFProceso.esValida) {
          alert(validFProceso.msg);
          return;
      }
    }

    if (!validarCampoString(formaPago, 2)) {
      alert('Debe especificar la forma de pago.');
      return;
    }

    if (formaPago === 'CR') {
      if (!validarCampoString(terminoPago, 2)) {
          alert('Debe especificar el término de pago.');
          return;
      }
    }

    if (this.state.detalleProforma.length === 0) {
      alert('La proforma no tiene items.');
      return;
    }

    if (this.state.operacion === 'M') {
      let articulosSinMotivoCambio =
          this.state.detalleProforma
            .filter(item => item.CantidadDespacho !== item.CantidadDespachoOrig
                        && (this.validarMotivoCambioVacio(item.MotivoCambio)))
            .map(item => item.Articulo);

      if (articulosSinMotivoCambio.length > 0) {
          alert('Debe ingresar el Motivo de Cambio de cantidad para los artículos: '.concat(articulosSinMotivoCambio.join(' - ')));
          return;
      }
    }

    if (!this.verificarPromocionesAplicadas()){
      return;
    }

    if (this.state.direccionesCliente.length > 1 && (this.state.operacion==='G' || (this.state.operacion==='M' && this.state.permitirModifCabProforma)) ){
      let continuarGuardado = window.confirm(`El cliente: ${cliente.label} tiene más de una dirección. Si Ud. seleccionó la dirección de envío correcta presione aceptar para continuar, sino cancelar.`);
        if (!continuarGuardado){
            return;
        }
    }

    let bodegaPrinc = this.getBodegaPrincipal();

    //SE PROCEDE A VALIDAR QUE SI EL CLIENTE TIENE DESCUENTOS ESTOS HAYAN SIDO APLICADOS, EN CASO DE NO TENER APLICADO EL DESCUENTO SE PROCEDE A MOSTRAR UN MENSAJE Y NO SE DEJA CONTINUAR.
    // Proceso para consultar si un cliente tiene descuentos habilitados:
    let codCliente = this.state.cliente_sel.value;
    this.props.cambiar_VisualizacionLoading(true);

    global_axios({
      method: 'GET',
      url: `/clientes/${codCliente}/descuentos?fechaExpiracion=${fechaProceso}`
    })
    .then((response)=> {
      this.props.cambiar_VisualizacionLoading(false);

      let esClienteDescuento=false;
      let poseeDescuentoAplicado=false;
      //Se procede a verificar si el cliente poseee descuentos
      if(response.data.length>0){
        //Se verifica que el descuento aplique a la forma de pago
        let descuento = response.data[0];
        if(descuento.FormaPago===formaPago){
          esClienteDescuento=true;
        }
        //Se procede a verificar que el descuento se aplico.
        if(esClienteDescuento){
          if(this.state.totalDscto>0){
              poseeDescuentoAplicado=true;
          }
          if(this.state.totalDsctoLinea > 0){
              poseeDescuentoAplicado=true;
          }
        }
      }

      if(esClienteDescuento&&!poseeDescuentoAplicado&&this.state.total>0){//Es cliente con descuento y no posee descuento aplicado entonces se enviara alerta y no se podra continuar.
        alert('El cliente posee descuentos, sin embargo no están aplicados. No se puede continuar.')
      }
      else{
        // Se procederá a guardar en caso que el cliente no sea un cliente con descuentos y no posea descuentos aplicados, tambien cuando el cliente sea un cliente con descuento y posea descuentos aplicados.
        this.props.cambiar_VisualizacionLoading(true);

        let url = (this.state.operacion==='G')?'/proformas':'/proformas/' + proformaId;
        let metodoRequest = (this.state.operacion==='G')?'POST': 'PUT';

        let data = (this.state.operacion==='G')?
            { proformas: this.generarProformasNuevas(cliente, fechaProceso, vendedor, terminoPago, formaPago, bodegaPrinc) }
            : this.generarProformaModificada(cliente, vendedor, terminoPago, formaPago, bodegaPrinc);

        const codEmpresa = JSON.parse(getItemDatosSesion('empresaActual')).Id;
        const usuario = getItemDatosSesion('usuario');
        const perfilId = JSON.parse(getItemDatosSesion('perfil')).Id;

        const payloadTrx = {    paramMaxItems: this.state.nroItemsPorProforma,
                                proformasDivididas: data.proformas?data.proformas.length:1,
                                dataProforma: data  }
        global_axios({
            url: '/logsauditoria',
            method: 'POST',
            data: { IsTrxLog: true,
                    CodEmpresa: codEmpresa,
                    Usuario: usuario,
                    PerfilId: perfilId,
                    Navegador: detectarNavegador(),
                    CodFormulario: '0402',
                    TipoTrx: this.state.operacion==='G'?'GUARDAR_PROFORMA':'MODIFICAR_PROFORMA',
                    PayloadTrx: payloadTrx
                 }
        })
        .then( response => console.debug("Log de transacción registrado exitosamente."))
        .catch(error => console.debug(`Error al registrar Log de transacción: ${error}`));

        global_axios({
          method: metodoRequest,
          url: url,
          data,
          headers: {idregaudit: this.props.idRegAudit}
        })
        .then((response)=> {
          this.props.cambiar_VisualizacionLoading(false);

          if (this.state.operacion ==='G'){

            if (response.data.codProformasGen === undefined || response.data.codProformasGen === null){
              alert('No se obtuvo la respuesta esperada del servidor sobre el proceso de generación de proformas.');
              return;
            }

            if (response.data.codProformasGen.length === 0){
              alert('No se generó(aron) la(s) proforma(s) correspondiente(s).');
              return;
            }
            let proformasAImprimir = [];
            if(!this.state.esProformaServicio){
              response.data.codProformasGen.forEach((proforma, i) => {
                proformasAImprimir.push({
                    Nro: (i+1),
                    NroDocumento: proforma,
                    EstadoImp: 'POR IMPRIMIR'
                });
              });

              this.props.setDocumentosPorImprimir(proformasAImprimir);
            }
          }else{
            if(!this.state.esProformaServicio){
              this.props.setDocumentosPorImprimir([{ Nro: 1, NroDocumento: proformaId, EstadoImp: 'POR IMPRIMIR'}]);
            }
          }

          if(this.state.esProformaServicio){
            this.setState({reservaId:undefined});
            alert('La proforma se generó correctamente.');
          }else{
            this.setState({reservaId:undefined, isVisibleCompGenPorImp: true});
          }
          this.setState({pedidoSeleccionado: {}, esBotonGuardarMod: true},()=>this.limpiar());
        })
        .catch((error)=> {
          this.props.cambiar_VisualizacionLoading(false);
          alert(error.response?error.response.data.msg:error.message);
        });
      }
    })
    .catch((error)=> {
        this.props.cambiar_VisualizacionLoading(false);
        alert(error.response?error.response.data.msg:error.message);
    });
  }

  generarProformaModificada(cliente, vendedor, terminoPago, formaPago, bodegaPrinc) {
      let detalleProformaGen = [];

      let subtotalGravaIva = parseFloat(0);
      let subtotalNoGravaIva = parseFloat(0);
      let total = parseFloat(0);
      let porcentajeGeneralIva = parseFloat(this.state.porcentIva);
      let porcentajeDscto = parseFloat(this.state.porcentajeDscto / 100);
      let valorIva = parseFloat(0);
      let totalDscto = parseFloat(0);
      let totalDsctoLinea = parseFloat(0);
      let valorFlete = 0;
      let totalDsctoPlazo = parseFloat(0);

      for (let i = 0; i < this.state.detalleProforma.length; i++) {

          let itemProf = this.state.detalleProforma[i];
          let reservaPorTransito = formatearNumeroEntero(itemProf.ReservaTransito === null ? 0 : itemProf.ReservaTransito);
          let cantidadDespacho = formatearNumeroEntero(itemProf.CantidadDespacho);

          detalleProformaGen.push({
              Articulo: itemProf.Articulo,
              Descripcion: (this.state.esProformaServicio) ? itemProf.Descripcion : '',
              Cantidad: itemProf.CantPedido,
              StockPrincipal: itemProf.StockPrincipal,
              StockAlterno: itemProf.StockAlterno,
              StockEnTransito: itemProf.StockTransito,
              Bodega: bodegaPrinc,
              Precio: itemProf.PrecioUnit,
              Descuento: itemProf.Descuento,
              GravaIva: itemProf.GravaIva,
              CostoPromedio: itemProf.CostoPromedio,
              ReservaTotal: cantidadDespacho,
              ReservaPrinc: itemProf.ReservaPrinc + reservaPorTransito,
              ReservaAlt: itemProf.ReservaAlt,
              EsPromocion: itemProf.EsPromocion === '*',
              SecReserva: itemProf.SecReserva,
              CantidadLiberada: itemProf.CantidadLiberada,
              ImportacionXLiberar: itemProf.ImportacionXLiberar,
              MotivoCambio: itemProf.MotivoCambio,
              VendidoOriginal: itemProf.VendidoOriginal
          });

          let cantidad = parseFloat(cantidadDespacho);
          let precioUnit = parseFloat(itemProf.PrecioUnit === null ? 0 : itemProf.PrecioUnit);
          let porcDescuento = parseFloat(itemProf.Descuento === null ? 0 : itemProf.Descuento);
          let porcentajedescuentoplazo = this.state.esProformaServicio ? 0 : parseFloat(this.state.porcentajeDsctoPlazo).toFixed(2);

          if (itemProf.Articulo.trim() === 'EMBA') {
              porcentajedescuentoplazo = 0;
          }

          let precUnitDesPlazo = parseFloat(multiplicarDecimales(precioUnit, parseFloat(porcentajedescuentoplazo) / 100));
          let precUnitDesPlazoDescontado = parseFloat(parseFloat(precioUnit) - parseFloat(precUnitDesPlazo));
          let valorDsctoPlazo = parseFloat(multiplicarDecimales(cantidad, parseFloat(precUnitDesPlazo))).toFixed(2);

          let precioUnitDscto = parseFloat(multiplicarDecimales(precUnitDesPlazoDescontado, porcDescuento / 100));
          let precioUnitDescontado = parseFloat(parseFloat(precUnitDesPlazoDescontado) - parseFloat(precioUnitDscto));
          let subTotalItem = parseFloat(multiplicarDecimales(cantidad, precioUnitDescontado)).toFixed(2);
          let subTotalDsctoItem = parseFloat(multiplicarDecimales(cantidad, precioUnitDscto)).toFixed(2);

          totalDsctoLinea = parseFloat(parseFloat(totalDsctoLinea) + parseFloat(subTotalDsctoItem)).toFixed(2);
          totalDsctoPlazo = parseFloat(parseFloat(totalDsctoPlazo) + parseFloat(valorDsctoPlazo)).toFixed(2);
          if (itemProf.GravaIva) {
              subtotalGravaIva = parseFloat(parseFloat(subtotalGravaIva) + parseFloat(subTotalItem)).toFixed(2);
          } else {
              subtotalNoGravaIva = parseFloat(parseFloat(subtotalNoGravaIva) + parseFloat(subTotalItem)).toFixed(2);
          }

          valorFlete += parseFloat(itemProf.Sublinea === 'SX' ? subTotalItem : 0);

          if (parseFloat(porcentajeDscto) > 0) {
              totalDscto = parseFloat(multiplicarDecimales(parseFloat(subtotalGravaIva) + parseFloat(subtotalNoGravaIva) - parseFloat(valorFlete), porcentajeDscto)).toFixed(2);
          }

          if (parseFloat(subtotalGravaIva) > parseFloat(totalDscto)) {
              subtotalGravaIva = parseFloat(parseFloat(subtotalGravaIva) - parseFloat(totalDscto)).toFixed(2);
          } else {
              subtotalNoGravaIva = parseFloat(parseFloat(subtotalNoGravaIva) - parseFloat(totalDscto)).toFixed(2);
          }

          valorIva = parseFloat(multiplicarDecimales(subtotalGravaIva, porcentajeGeneralIva / 100)).toFixed(2);
          total = parseFloat(parseFloat(subtotalNoGravaIva) + parseFloat(subtotalGravaIva) + parseFloat(valorIva)).toFixed(2);
      }

      let data = {
          Cliente: cliente.value,
          FormaPago: formaPago,
          Caja: this.state.cajaGen,
          Bodega: bodegaPrinc,
          Total: parseFloat(total),
          PorcIva: parseFloat(porcentajeGeneralIva),
          Iva: parseFloat(valorIva),
          SubTotalConIva: parseFloat(subtotalGravaIva),
          SubTotalSinIva: parseFloat(subtotalNoGravaIva),
          Vendedor: vendedor.value,
          TipoDescuento: 'P',
          ValorDescuento: parseFloat(totalDscto),
          Descuento: parseFloat(this.state.porcentajeDscto),
          DescuentoLinea: parseFloat(totalDsctoLinea),
          Usuario: getItemDatosSesion('usuario').toString(),
          Moneda: JSON.parse(getItemDatosSesion('moneda')).Moneda,
          Dolar: JSON.parse(getItemDatosSesion('moneda')).Cotizacion,
          Gracia: this.state.diasGracia,
          TerminoPago: terminoPago,
          Pedido: this.state.pedidoSeleccionado ? this.state.pedidoSeleccionado.Pedido : null,
          Reserva: (this.state.reservaId) ? this.state.reservaId.toString() : '',
          CodDireccion: (this.state.direccion_sel === null || this.state.direccion_sel === 0) ? null : this.state.direccion_sel,
          Devolucion: this.state.Devolucion,
          DsctoClienteId: this.state.dsctoClienteId,
          totalDsctoPlazo,
          porcentajeDsctoPlazo: this.state.porcentajeDsctoPlazo,
          detalleProforma: detalleProformaGen,
          articulosEliminados: this.state.articulosEliminados
      }

      return data;
  }

  generarProformasNuevas(cliente, fecha, vendedor, terminoPago, formaPago, bodegaPrinc) {
      let proformasGen = [];
      let detalleProformaGen = [];
      let contItems = 1;

      let subtotalGravaIva = parseFloat(0);
      let subtotalNoGravaIva = parseFloat(0);
      let total = parseFloat(0);
      let porcentajeGeneralIva = parseFloat(this.state.porcentIva);
      let porcentajeDscto = parseFloat(this.state.porcentajeDscto / 100);
      let valorIva = parseFloat(0);
      let totalDscto = parseFloat(0);
      let totalDsctoLinea = parseFloat(0);
      let valorFlete = 0;
      let totalDsctoPlazo = parseFloat(0);
      /*  Se realiza dos corridas para generar por separado los tipos de proforma:
          j=0.- POR STOCK FISICO
          j=1.- POR STOCK EN TRANSITO
      */

      for (let j = 0; j <= 1; j++) {
          for (let i = 0; i < this.state.detalleProforma.length; i++) {

              let itemProf = this.state.detalleProforma[i];
              let reservaPorTransito = formatearNumeroEntero(itemProf.ReservaTransito === null ? 0 : itemProf.ReservaTransito);
              let articuloAgreg = 0;
              let cantidadDespacho = 0;
              let cantidadDespachoBodega = formatearNumeroEntero(itemProf.CantidadDespacho) - formatearNumeroEntero(reservaPorTransito);

              // STOCK FISICO
              if (j === 0) {
                  cantidadDespacho = cantidadDespachoBodega;

                  if (cantidadDespacho > 0 || (cantidadDespacho === 0 && reservaPorTransito === 0)) {
                      articuloAgreg = 1;
                      detalleProformaGen.push({
                          Articulo: itemProf.Articulo,
                          Descripcion: (this.state.esProformaServicio) ? itemProf.Descripcion : '',
                          Cantidad: itemProf.CantPedido,
                          StockPrincipal: itemProf.StockPrincipal,
                          StockAlterno: itemProf.StockAlterno,
                          StockEnTransito: itemProf.StockTransito,
                          Bodega: bodegaPrinc,
                          Precio: itemProf.PrecioUnit,
                          Descuento: itemProf.Descuento,
                          GravaIva: itemProf.GravaIva,
                          CostoPromedio: itemProf.CostoPromedio,
                          ReservaTotal: cantidadDespacho,
                          ReservaPrinc: itemProf.ReservaPrinc,
                          ReservaAlt: itemProf.ReservaAlt,
                          EsPromocion: itemProf.EsPromocion === '*',
                          SecReserva: itemProf.SecReserva,
                          CantidadLiberada: itemProf.CantidadLiberada,
                          ImportacionXLiberar: itemProf.ImportacionXLiberar,
                          MotivoCambio: itemProf.MotivoCambio,
                          VendidoOriginal: itemProf.VendidoOriginal
                      });
                  }
              }
              // STOCK EN TRANSITO
              else {
                  if (reservaPorTransito > 0) {
                      articuloAgreg = 1;
                      cantidadDespacho = reservaPorTransito;

                      detalleProformaGen.push({
                          Articulo: itemProf.Articulo,
                          Descripcion: (this.state.esProformaServicio) ? itemProf.Descripcion : '',
                          Cantidad: formatearNumeroEntero(itemProf.CantPedido) - cantidadDespachoBodega,
                          StockPrincipal: itemProf.StockPrincipal,
                          StockAlterno: itemProf.StockAlterno,
                          StockEnTransito: itemProf.StockTransito,
                          Bodega: bodegaPrinc,
                          Precio: itemProf.PrecioUnit,
                          Descuento: itemProf.Descuento,
                          GravaIva: itemProf.GravaIva,
                          CostoPromedio: itemProf.CostoPromedio,
                          ReservaTotal: cantidadDespacho,
                          ReservaPrinc: reservaPorTransito,
                          ReservaAlt: 0,
                          EsPromocion: false,
                          SecReserva: itemProf.SecReserva,
                          CantidadLiberada: itemProf.CantidadLiberada,
                          ImportacionXLiberar: itemProf.ImportacionXLiberar,
                          MotivoCambio: itemProf.MotivoCambio,
                          VendidoOriginal: itemProf.VendidoOriginal
                      });
                  }
              }

              if (articuloAgreg === 1) {
                  let cantidad = parseFloat(cantidadDespacho);
                  let precioUnit = parseFloat(itemProf.PrecioUnit === null ? 0 : itemProf.PrecioUnit);
                  let porcDescuento = parseFloat(itemProf.Descuento === null ? 0 : itemProf.Descuento);
                  let porcentajedescuentoplazo = this.state.esProformaServicio ? 0 : parseFloat(this.state.porcentajeDsctoPlazo).toFixed(2);

                  if (itemProf.Articulo.trim() === 'EMBA') {
                      porcentajedescuentoplazo = 0;
                  }

                  let precUnitDesPlazo = parseFloat(multiplicarDecimales(precioUnit, parseFloat(porcentajedescuentoplazo) / 100));
                  let precUnitDesPlazoDescontado = parseFloat(parseFloat(precioUnit) - parseFloat(precUnitDesPlazo));
                  let valorDsctoPlazo = parseFloat(multiplicarDecimales(cantidad, parseFloat(precUnitDesPlazo))).toFixed(2);

                  let precioUnitDscto = parseFloat(multiplicarDecimales(precUnitDesPlazoDescontado, porcDescuento / 100));
                  let precioUnitDescontado = parseFloat(parseFloat(precUnitDesPlazoDescontado) - parseFloat(precioUnitDscto));
                  let subTotalItem = parseFloat(multiplicarDecimales(cantidad, precioUnitDescontado)).toFixed(2);
                  let subTotalDsctoItem = parseFloat(multiplicarDecimales(cantidad, precioUnitDscto)).toFixed(2);

                  totalDsctoLinea = parseFloat(parseFloat(totalDsctoLinea) + parseFloat(subTotalDsctoItem)).toFixed(2);
                  totalDsctoPlazo = parseFloat(parseFloat(totalDsctoPlazo) + parseFloat(valorDsctoPlazo)).toFixed(2);
                  if (itemProf.GravaIva) {
                      subtotalGravaIva = parseFloat(parseFloat(subtotalGravaIva) + parseFloat(subTotalItem)).toFixed(2);
                  } else {
                      subtotalNoGravaIva = parseFloat(parseFloat(subtotalNoGravaIva) + parseFloat(subTotalItem)).toFixed(2);
                  }

                  valorFlete += parseFloat(itemProf.Sublinea === 'SX' ? subTotalItem : 0);

                  if (contItems < formatearNumeroEntero(this.state.nroItemsPorProforma) && contItems < this.state.detalleProforma.length) {
                      contItems += 1;
                  } else {
                      if (parseFloat(porcentajeDscto) > 0) {
                          totalDscto = parseFloat(multiplicarDecimales(parseFloat(subtotalGravaIva) + parseFloat(subtotalNoGravaIva) - parseFloat(valorFlete), porcentajeDscto)).toFixed(2);
                      }

                      if (parseFloat(subtotalGravaIva) > parseFloat(totalDscto)) {
                          subtotalGravaIva = parseFloat(parseFloat(subtotalGravaIva) - parseFloat(totalDscto)).toFixed(2);
                      } else {
                          subtotalNoGravaIva = parseFloat(parseFloat(subtotalNoGravaIva) - parseFloat(totalDscto)).toFixed(2);
                      }

                      valorIva = parseFloat(multiplicarDecimales(subtotalGravaIva, porcentajeGeneralIva / 100)).toFixed(2);
                      total = parseFloat(parseFloat(subtotalNoGravaIva) + parseFloat(subtotalGravaIva) + parseFloat(valorIva)).toFixed(2);

                      let data = {
                          Cliente: cliente.value,
                          Fecha: fecha,
                          FormaPago: formaPago,
                          Caja: this.state.cajaGen,
                          Bodega: bodegaPrinc,
                          Total: parseFloat(total),
                          PorcIva: parseFloat(porcentajeGeneralIva),
                          Iva: parseFloat(valorIva),
                          SubTotalConIva: parseFloat(subtotalGravaIva),
                          SubTotalSinIva: parseFloat(subtotalNoGravaIva),
                          Vendedor: vendedor.value,
                          TipoDescuento: 'P',
                          ValorDescuento: parseFloat(totalDscto),
                          Descuento: parseFloat(this.state.porcentajeDscto),
                          DescuentoLinea: parseFloat(totalDsctoLinea),
                          Usuario: getItemDatosSesion('usuario').toString(),
                          Moneda: JSON.parse(getItemDatosSesion('moneda')).Moneda,
                          Dolar: JSON.parse(getItemDatosSesion('moneda')).Cotizacion,
                          Gracia: this.state.diasGracia,
                          TerminoPago: terminoPago,
                          Pedido: this.state.pedidoSeleccionado ? this.state.pedidoSeleccionado.Pedido : null,
                          Reserva: (this.state.reservaId) ? this.state.reservaId.toString() : '',
                          CodDireccion: (this.state.direccion_sel === null || this.state.direccion_sel === 0) ? null : this.state.direccion_sel,
                          Tipo: (this.state.esProformaServicio) ? 'S' : (j === 1 ? 'T' : 'B'),
                          Devolucion: this.state.Devolucion,
                          DsctoClienteId: this.state.dsctoClienteId,
                          EsCopiada: this.state.esCopiada,
                          ProformaOriginal: this.state.proformaCopiadaId,
                          totalDsctoPlazo,
                          porcentajeDsctoPlazo: this.state.porcentajeDsctoPlazo,
                          detalleProforma: detalleProformaGen
                      }
                      proformasGen.push(data);
                      detalleProformaGen = [];

                      contItems = 1;
                      subtotalGravaIva = parseFloat(0);
                      subtotalNoGravaIva = parseFloat(0);
                      total = parseFloat(0);
                      valorIva = parseFloat(0);
                      totalDsctoLinea = parseFloat(0);
                      totalDscto = parseFloat(0);
                      totalDsctoPlazo = parseFloat(0);
                  }
              }
          }

          if (detalleProformaGen.length > 0) {
              if (parseFloat(porcentajeDscto) > 0) {
                  totalDscto = parseFloat(multiplicarDecimales(parseFloat(subtotalGravaIva) + parseFloat(subtotalNoGravaIva) - parseFloat(valorFlete), porcentajeDscto)).toFixed(2);
              }

              if (parseFloat(subtotalGravaIva) > parseFloat(totalDscto)) {
                  subtotalGravaIva = parseFloat(parseFloat(subtotalGravaIva) - parseFloat(totalDscto)).toFixed(2);
              } else {
                  subtotalNoGravaIva = parseFloat(parseFloat(subtotalNoGravaIva) - parseFloat(totalDscto)).toFixed(2);
              }

              valorIva = parseFloat(multiplicarDecimales(subtotalGravaIva, porcentajeGeneralIva / 100)).toFixed(2);
              total = parseFloat(parseFloat(subtotalNoGravaIva) + parseFloat(subtotalGravaIva) + parseFloat(valorIva)).toFixed(2);

              let data = {
                  Cliente: cliente.value,
                  Fecha: fecha,
                  FormaPago: formaPago,
                  Caja: this.state.cajaGen,
                  Bodega: bodegaPrinc,
                  Total: parseFloat(total),
                  PorcIva: parseFloat(porcentajeGeneralIva),
                  Iva: parseFloat(valorIva),
                  SubTotalConIva: parseFloat(subtotalGravaIva),
                  SubTotalSinIva: parseFloat(subtotalNoGravaIva),
                  Vendedor: vendedor.value,
                  TipoDescuento: 'P',
                  ValorDescuento: parseFloat(totalDscto),
                  Descuento: parseFloat(this.state.porcentajeDscto),
                  DescuentoLinea: parseFloat(totalDsctoLinea),
                  Usuario: getItemDatosSesion('usuario').toString(),
                  Moneda: JSON.parse(getItemDatosSesion('moneda')).Moneda,
                  Dolar: JSON.parse(getItemDatosSesion('moneda')).Cotizacion,
                  Gracia: this.state.diasGracia,
                  TerminoPago: terminoPago,
                  Pedido: this.state.pedidoSeleccionado ? this.state.pedidoSeleccionado.Pedido : null,
                  Reserva: (this.state.reservaId) ? this.state.reservaId.toString() : '',
                  CodDireccion: (this.state.direccion_sel === null || this.state.direccion_sel === 0) ? null : this.state.direccion_sel,
                  Tipo: (this.state.esProformaServicio) ? 'S' : (j === 1 ? 'T' : 'B'),
                  Devolucion: this.state.Devolucion,
                  DsctoClienteId: this.state.dsctoClienteId,
                  EsCopiada: this.state.esCopiada,
                  totalDsctoPlazo,
                  porcentajeDsctoPlazo: this.state.porcentajeDsctoPlazo,
                  detalleProforma: detalleProformaGen
              }

              proformasGen.push(data);
              detalleProformaGen = [];

              contItems = 1;
              subtotalGravaIva = parseFloat(0);
              subtotalNoGravaIva = parseFloat(0);
              total = parseFloat(0);
              valorIva = parseFloat(0);
              totalDsctoLinea = parseFloat(0);
              totalDscto = parseFloat(0);
              totalDsctoPlazo = parseFloat(0);
          }
      }

      return proformasGen;
  }
  
  getBodegaPrincipal(){
    let codigoBodega = null;
    this.props.puntosFacturacion.forEach(ptoFact=>{
      if (ptoFact.Codigo===this.props.puntoFacturacionSel){
        codigoBodega = ptoFact.Bodega;
      }
    });

    return codigoBodega;
  }
  
  getProformaById(){
    let idProforma = this.state.proformaId;
    if (validarCampoString(idProforma, 6)){      
      this.props.cambiar_VisualizacionLoading(true);
      let fechaProceso = getFechaProcesoPorModulo('04');

      global_axios({
        method: 'GET',
        url: '/proformas/' + idProforma,
      })
      .then((response)=> {
        let proforma = response.data;
        if (proforma!==null){
          let detProforma = proforma.det_proforma
              .map(itProforma =>({
                      EsPromocion: itProforma.EsPromocion===true?'*':'',
                      NroItem: itProforma.Secuencia,
                      Articulo: itProforma.Articulo,
                      Descripcion: itProforma.NombreArtic,
                      CantPedido: itProforma.Cantidad,
                      CantPorDespachar: itProforma.ReservaTotal,
                      StockPrincipal: itProforma.StockPrinc,
                      StockAlterno: itProforma.StockAlt,
                      StockTransito: itProforma.CantEnTrans,
                      CantidadDespacho: itProforma.ReservaTotal,
                      GravaIva: itProforma.Iva,
                      PrecioUnit: itProforma.Precio,
                      CostoPromedio: itProforma.CostoPromedio,
                      Descuento: itProforma.Descuento,
                      DescuentoOrig: itProforma.DescuentoOrig,
                      ReservaPrinc: itProforma.Reserva,
                      ReservaAlt: itProforma.ReservaAlt,
                      ReservaTransito: itProforma.ReservaTrans,
                      EsEditable: itProforma.EsEditable,
                      Sublinea: itProforma.Sublinea,
                      TipoCompra: itProforma.TipoCompra,
                      SecReserva: itProforma.SecReserva,
                      CantidadLiberada: itProforma.CantidadLiberada,
                      ImportacionXLiberar: itProforma.ImportacionXLiberar,
                      MotivoCambio: itProforma.UltMotivoCambio,
                      CantidadDespachoOrig: itProforma.ReservaTotal,
                      VendidoOriginal: itProforma.VendidoOriginal
              })
          );
          
          this.setState({
            operacion: 'M',
            reservaId: proforma.Reserva,
            cliente_sel: generarItemCatalogoSeleccionado(proforma.cli.Codigo, proforma.cli.Nombre),
            tipoCliente_sel: proforma.cli.Tipo,
            vendedor_sel: generarItemCatalogoSeleccionado(proforma.vend.Codigo, proforma.vend.Nombre),
            formaPago_sel: proforma.FormaPago,
            terminoPago_sel: proforma.TerminoPago,
            fechaProforma: moment(proforma.fecha, 'DD/MM/YYYY'),
            detalleProforma: detProforma,
            estadoActual: proforma.Status.trim().toUpperCase(),
            cabeceraEsModificable: proforma.Status.trim().toUpperCase()==='P',
            detalleEsModificable: (proforma.Status.trim().toUpperCase()==='P' && proforma.EncartonadoId === null),
            porcentIva: parseFloat(proforma.PorcentajeIva),
            esProformaServicio: proforma.Tipo.trim().toUpperCase()==='S',
            Devolucion: proforma.ParaDevolucion,
            porcentajeDscto: parseFloat(proforma.Descuento),
            embalaje: proforma.embalaje,
            pedidoSeleccionado: {Pedido: proforma.Obra===null?'':proforma.Obra},
            idFactura: proforma.Factura,
            nroFactura: proforma.fact?`${proforma.fact.Establecimiento}-${proforma.fact.PtoEmision}-${proforma.fact.NroFactura}`:'',
            dsctoClienteId: proforma.DsctoClienteId,
            descripTipoProformaProd: (proforma.Tipo.trim().toUpperCase()==='S')?'':` - ${proforma.tipoProf.Descripcion} -`,
            tipoProforma: proforma.Tipo.trim().toUpperCase(),
            porcentajeDsctoPlazo: parseFloat(proforma.PorcentajeDsctoPlazo),
            encartonadoId: proforma.EncartonadoId,
            habilitarTerPago:false
          });

          this.state.gridDetProformaColumnApi.setColumnVisible('MotivoCambio', true);

          this.props.cambiar_VisualizacionLoading(false);

          if (proforma.CodDireccion !== null){
            this.generarDireccionesCliente(proforma.cli, proforma.CodDireccion);
          }else{
            this.generarDireccionesCliente(proforma.cli);
          }

          // Proceso para consultar si un cliente tiene descuentos habilitados:
          global_axios({
            method: 'GET',
            url: `/clientes/${proforma.cli.Codigo}/descuentos?fechaExpiracion=${fechaProceso}`
          })
          .then((response)=> {
            this.setState({descuentosCliente: response.data}, () =>{
              this.aplicarDescuentosPorCliente(proforma.cli.Codigo, this.state.formaPago_sel);
            });
          })
          .catch((error)=> {
            alert(error.response?error.response.data.msg:error.message);
          });

        }else{
          this.props.cambiar_VisualizacionLoading(false);
          alert(`La proforma: ${idProforma} no existe.`);
        }
      })
      .catch((error)=>{
        this.props.cambiar_VisualizacionLoading(false);
        alert(error.response?error.response.data.msg:error.message);
      });
    }
    else{
      alert('No ha especificado un No. de Proforma válido.');
    }
  }
  
  replicarProforma(){
    if(!this.state.permitirGeneracionProforma) {
      alert(msgErrorPermisoGeneracionProforma);
      return;
    }

    let proformaId = this.state.proformaId;
    
    if (!validarCampoString(proformaId, 1, 6)){
      alert('Ud. no ha seleccionado la proforma que desea replicar');
      return;
    }

    if (this.state.detalleProforma.length === 0){
      alert('No existen items en la proforma a replicar.');
      return;
    }

    this.props.cambiar_VisualizacionLoading(true);
    let fechaProceso = getFechaProcesoPorModulo('04');

    let dataInputReserva = {  pedidoMovil: null, pedidoPorDevol: null, tipoCliente: this.state.tipoCliente_sel,
                              idPtoFacturacion: this.props.puntoFacturacionSel, articulos: [],
                              fechaReserva: fechaProceso };

    let nroItemsProforma = this.state.detalleProforma.length;
    for(let i=0; i<nroItemsProforma; i++){
      let itemProf = this.state.detalleProforma[i];      

      if(itemProf.Sublinea!=='SX' && itemProf.EsPromocion===''){
        dataInputReserva.articulos.push({Articulo: itemProf.Articulo, Cantidad: parseFloat(itemProf.CantPedido)});      
      }
    }    

    if(dataInputReserva.articulos.length===0){
      alert('No existen items en la proforma que se puedan replicar.');
      return;
    }

    /* Se procesa la reserva de stock de los artículos de la proforma a copiar */
  
    global_axios({
      method: 'POST',
      url: '/reservasstock',
      data: dataInputReserva
    })
    .then((response)=> {
      let detalleReserva = response.data;

      let itemsProforma = [];
      detalleReserva.forEach((itemReserva, indice)=>{         
          /* Se guarda el Id de la reserva que se genere */
          if (indice===0){
            this.setState({reservaId: itemReserva.Reserva});
          }

          /* Se genera cada item de la proforma con los datos del pedido, stock y reserva generada */
            itemsProforma.push({
              EsPromocion: '',
              NroItem: completar_String((indice + 1).toString(), '0', 3),
              Articulo: itemReserva.Articulo,
              Descripcion: itemReserva.NombreArticulo,
              CantPedido: itemReserva.CantPedido,
              CantPorDespachar: itemReserva.CantPedido,
              StockPrincipal: itemReserva.StockPrincipal,
              StockAlterno: itemReserva.StockAlterno,
              StockTransito: itemReserva.CantEnTransito,
              CantidadDespacho: itemReserva.CantReservaTotal,
              ReservaPrinc: itemReserva.CantReservaPrinc===null?0:itemReserva.CantReservaPrinc,
              ReservaAlt: itemReserva.CantReservaAlt===null?0:itemReserva.CantReservaAlt,
              ReservaTransito: itemReserva.CantReservaTrans===null?0:itemReserva.CantReservaTrans,
              PrecioUnit: itemReserva.PrecioUnit,
              CostoPromedio: itemReserva.CostoPromedio,
              GravaIva: itemReserva.GravaIva,
              Descuento: itemReserva.Descuento,
              DescuentoOrig: itemReserva.Descuento,
              EsEditable: itemReserva.Sublinea!=='SX',
              Sublinea: itemReserva.Sublinea,
              TipoCompra: itemReserva.TipoCompra,
              SecReserva: itemReserva.Secuencia,
              CantidadLiberada: null,
              ImportacionXLiberar: null,
              MotivoCambio: null,
              CantidadDespachoOrig: itemReserva.CantReservaTotal,
              VendidoOriginal: itemReserva.CantReservaTotal
            });
      });

      this.setState({ operacion:'G', proformaCopiadaId: this.state.proformaId, estadoActual: 'P',
                      proformaId: '', detalleProforma: itemsProforma, existenCambiosEnDetalle: true,
                      fechaProforma: moment(fechaProceso, 'DD/MM/YYYY'),
                      detalleEsModificable: true, dsctoClienteId: null, embalaje: null, idFactura: null,
                      esCopiada:'S', encartonadoId: ''
      }, ()=>{
        this.aplicarDescuentosPorCliente(this.state.cliente_sel.value, this.state.formaPago_sel);
      });

      this.props.cambiar_VisualizacionLoading(false);
      
    })
    .catch((error)=> {
      this.props.cambiar_VisualizacionLoading(false);
      alert(error.response?error.response.data.msg:error.message);  
    });
  }

  restarFechas(f1,f2){
    var aFecha1 = f1.split('/');
    var aFecha2 = f2.split('/');
    var fFecha1 = Date.UTC(aFecha1[2],aFecha1[1]-1,aFecha1[0]);
    var fFecha2 = Date.UTC(aFecha2[2],aFecha2[1]-1,aFecha2[0]);
    var dif = fFecha2 - fFecha1;
    return Math.floor(dif / (1000 * 60 * 60 * 24));
  }

  validarGeneracionFactura(){
    if(!this.state.permitirFacturacion){
        alert(msgErrorPermisoFacturacion);
        return;
    }

    let proforma = this.state.proformaId;
    let estadoProforma = this.state.estadoActual;

    if (this.state.operacion!=='M'){
      alert('No ha seleccionado una proforma para facturar.');
      return;
    }

    if (!validarCampoString(proforma, 6)){
      alert('No ha seleccionado una proforma para facturar.');
      return;
    }

    if (estadoProforma!=='P'){
      alert('El estado actual de la proforma no permite generar factura.');
      return;
    }

    if (this.state.embalaje===null || this.state.embalaje===undefined){
      alert('La proforma actual no tiene la asignación de embalaje que requiere.');
      return;
    }else{
      if (this.state.embalaje.cobroEmbalaje){ // Revisión para determinar si se debe cobrar embalaje al cliente actual.
        if (this.state.embalaje.cobroEmbalajeEstablec==='N'){ // Revisión para determinar si ya se asignó el cobro de embalaje a la proforma actual.
          alert('La proforma actual no tiene la asignación de embalaje que requiere.');
          return;
        }
      }
    }

    let puedeContinuar=true;
    this.props.cargar_Proformas('ConsultaPorEstadoPendiente', 'P')
    .then(()=>{
      let proformasPendFact = [];
      this.props.proformas.forEach(proforma=>{
        proformasPendFact.push({
          ...proforma
        });
      });
      let fechaProceso = getFechaProcesoPorModulo('04');
      let fechaProforma = formatearFechaMoment_a_String(this.state.fechaProforma);
      if((fechaProforma === fechaProceso) && this.state.parametroProforma==='S'){
        if(proformasPendFact.length>0){
            puedeContinuar=false;
            this.setState({proformasPendFactura:proformasPendFact, isVisibleModalProfPendFact:true, esDetallePendiente:true},()=>{
              alert('Se poseen las siguientes proformas pendientes, Por favor facturarlas para proseguir...')
            })
        }
      }
     
      if(puedeContinuar){
        /* Revisión de la existencia de otras proformas pendientes de facturar relacionadas con el pedido móvil actual.
          Si existen otras proformas relacionadas con el pedido móvil se envia un alerta para que el usuario decida si
          quiere continuar generando la factura actual.
        */
    
        if (validarCampoString(this.state.pedidoSeleccionado.Pedido, 6, 10)){
    
          let pedidoMovil = this.state.pedidoSeleccionado.Pedido;
          let url = `/proformas?operacion=ConsultaPorPedidoMovil&estado=P&pedidomovil=${pedidoMovil}`;
          
          global_axios({
            method: 'GET',
            url
          })
          .then( response => {
            let proformas = response.data;
            // Si existe más de 1 proforma relacionada con el pedido se envía alerta.
            if (proformas.length>1){
              let proformasRelacionadas = '';
              proformas.forEach(proforma=>{
                if (proforma.Proforma !== this.state.proformaId)
                proformasRelacionadas += `\nProforma: ${proforma.Proforma}`;
              });
    
              let msgAlerta = `Existen otras proformas pendientes de facturar relacionadas con el Pedido Móvil: ${pedidoMovil}${proformasRelacionadas}.\nDesea continuar?`;
              let continuarFact = window.confirm(msgAlerta);
    
              if (continuarFact){
                this.generarFactura(proforma);
              }else{
                return;
              }
            }else{
              this.generarFactura(proforma);
            }
          })
          .catch(error=>{
            alert(`No es posible validar la existencia de otras proformas relacionadas con el Pedido Móvil. Error: ${error.response?error.response.data.msg:error.message}`);          
          });
        }else{
          this.generarFactura(proforma);
        }    
      }else{
        this.props.cambiar_VisualizacionLoading(false);
      } 
    });
  }

  generarFactura(proforma){

    let fechaProceso = getFechaProcesoPorModulo('04');

    let dataFactura = { Proforma: proforma, PtoFacturacion: this.props.puntoFacturacionSel,
                        Usuario: getItemDatosSesion('usuario'), FechaEmision: fechaProceso };
    if(this.state.existenCambiosEnDetalle){
      alert('Para facturar es necesario que guarde los cambios realizados.')
      return;
    }

    this.props.cambiar_VisualizacionLoading(true);

    global_axios({
      method: 'POST',
      url: '/facturas',
      data: dataFactura
    })
    .then((response)=> {
      this.props.cambiar_VisualizacionLoading(false);
      if (response.status===201){
        let facturaId = response.data.codigoFactura;
        alert('Se generó y preautorizó correctamente la factura correspondiente.');
        visualizarReporteEnPdf('&rpt=3&param1=' + facturaId);
      }else{
        alert('El proceso de generación de factura se ejecutó correctamente pero ninguna factura fue generada en vista de que la proforma seleccionada no contiene items vendidos.')
      }
      this.setState({reservaId:undefined});
      this.limpiar();
    })
    .catch((error)=>{
      this.props.cambiar_VisualizacionLoading(false);
      alert(error.response?error.response.data.msg:error.message);
    });
  }

  imprimirProforma(){
    let proforma = this.state.proformaId;

    if ((this.state.operacion!=='M') || (!validarCampoString(proforma, 6)) ){
      alert('No ha seleccionado una proforma para imprimir.');
      return;
    }
    
    visualizarReporteEnPdf('&rpt=2&param1=' + proforma);
    if(this.state.permitirConsultaProformasXImprimir) {
        this.registrarEventoDeProforma(proforma, 'IMPRESION_PROF_EN_BODEGA');
    }
  }

  registrarEventoDeProforma(proforma, tipoEvento) {
      global_axios({
          method: 'POST',
          url: `/proformas/${proforma}/eventos`,
          data: {evento: tipoEvento, usuario: getItemDatosSesion('usuario')},
          headers: {idregaudit: this.props.idRegAudit}
      })
      .catch(error => void error);
  }

  imprimirFactura(){
    let proforma = this.state.proformaId;
    let facturaId = this.state.idFactura;

    if ((this.state.operacion!=='M') || (!validarCampoString(proforma, 6)) ){
      alert('No ha seleccionado una proforma para imprimir la factura relacionada.');
      return;
    }

    if ((this.state.estadoActual!=='F') || (!validarCampoString(facturaId, 6))){
      alert('La proforma seleccionada no tiene una factura relacionada.');
      return
    }

    visualizarReporteEnPdf('&rpt=3&param1=' + facturaId);
  }

  anularProforma(){
    if(!this.state.permitirAnulacionProforma){
        alert(msgErrorPermisoAnulacionProforma);
        return;
    }

    let proforma = this.state.proformaId;
    let estadoProforma = this.state.estadoActual;

    if (this.state.operacion!=='M'){
      alert('No ha seleccionado una proforma para anular.');
      return;
    }

    if (!validarCampoString(proforma, 6)){
      alert('No ha seleccionado una proforma para anular.');
      return;
    }

    if (estadoProforma!=='P'){
      alert('El estado actual de la proforma no permite que se anule.');
      return;
    }

    if (this.state.operacion==='M' && this.state.detalleEsModificable===false){
      alert('La anulación de ésta proforma no está permitida.');
      return;
    }

    let continuarAnul = window.confirm('¿Está seguro de anular la Proforma No.: ' + proforma + '?');
  
    if (!continuarAnul){
      return;
    }

    this.props.cambiar_VisualizacionLoading(true);

    global_axios({
      method: 'DELETE',
      url: '/proformas/' + proforma,
      headers: {idregaudit: this.props.idRegAudit}
    })
    .then(()=> {
      this.props.cambiar_VisualizacionLoading(false);      
      alert('La proforma fue anulada correctamente.');
      this.setState({reservaId:undefined});
      this.limpiar();
    })
    .catch((error)=>{
      this.props.cambiar_VisualizacionLoading(false);
      alert(error.response?error.response.data.msg:error.message);
    });  
  }

  changeFormaPago(value){
      let porcentajeDsctoPlazo=0;
      if(!this.state.esProformaServicio)
      {
        porcentajeDsctoPlazo = value!==null?value.descuento:0
      }
      if(!this.state.parametroDescuentoPlazo){
        porcentajeDsctoPlazo=0;
      }
      
      let fechaProceso = getFechaProcesoPorModulo('04');
      fechaProceso= moment(fechaProceso, 'DD/MM/YYYY')
      
      let fechaDsctoPlazo=moment(this.state.fechaDsctoPlazo, 'YYYY/MM/DD');
     
      if(fechaProceso<fechaDsctoPlazo){
        porcentajeDsctoPlazo=0;
      }
      
      this.setState({terminoPago_sel: value!==null?value.value:null, porcentajeDsctoPlazo:porcentajeDsctoPlazo},()=>{
        this.calculoTotales();
        this.state.gridDetProformaApi.refreshCells();
      })
  }

  render(){
    let cantItemsEnPromocionVend = 0;
    let cantItemsRegalados = 0;
    let lineasArticEnPromoc = [];
    let promocionVigente = null;
    
    if (this.state.promocionesVigentes.length>0){
      cantItemsEnPromocionVend = this.contarArticulosPorTipoCompraEnProforma('Todos', 'VENDIDO');
      cantItemsRegalados = this.contarArticulosPorTipoCompraEnProforma('Todos', 'PROMOCION');
      promocionVigente = this.state.promocionesVigentes[0];
      lineasArticEnPromoc = promocionVigente.detPromo;
    }
    
    return(
      <div>
        <ContenedorForm porc_ancho={92}>
          <HeaderForm>
            <ContainerAlineado>
              <span>
                <TituloForm>Tipo Proforma:</TituloForm>
                <ToggleSwitch
                  checked={this.state.esProformaServicio}
                  onChange={() => this.setState({ esProformaServicio: !this.state.esProformaServicio, articulo_Sel:null, cantidadArt: '' })}
                  size='sm'
                  disabled={!(this.state.permitirGeneracionProforma && this.state.operacion==='G')}
                />
                <LabelTipoProf>{this.state.esProformaServicio?'Servicios': `Productos ${this.state.descripTipoProformaProd}`}</LabelTipoProf>
              </span>
              <LabelCabecera>Fecha Proceso: {getFechaProcesoPorModulo('04')}</LabelCabecera>
              <LabelCabecera>Proforma Copiada: {this.state.proformaCopiadaId===undefined?'':this.state.proformaCopiadaId}</LabelCabecera>
              <LabelCabecera>Encartonado: {this.state.encartonadoId===null?'':this.state.encartonadoId}</LabelCabecera>
              <LabelCabecera>Reserva: {this.state.reservaId===undefined?'':this.state.reservaId}</LabelCabecera>
              <LabelCabecera>Pedido Móvil: {this.state.pedidoSeleccionado===undefined?'':this.state.pedidoSeleccionado.Pedido}</LabelCabecera>
              <LabelCabecera>Últ. Proforma: {this.state.secuencialProforma===undefined?'':this.state.secuencialProforma}</LabelCabecera>
            </ContainerAlineado>
          </HeaderForm>
          <CuerpoForm>
            <Row>
              <ContainerCol className='col-sm-2'>
                <LabelForm>Proforma:</LabelForm>
                <InputSearch tipoInput='text' nombre='proformaId' placeholder='Proforma' valor={this.state.proformaId} disabled={this.state.existenCambiosEnDetalle} func_CambiarValor={this.handleInputChange}
                  func_BuscarValor={this.getProformaById} func_OnFocus={()=>this.limpiar()}/>
              </ContainerCol>
              <ContainerCol className='col-sm-2'>
                <LabelForm>Fecha:</LabelForm>                
                <PickerFecha fechaSeleccionada={this.state.fechaProforma} disabled={!(this.props.permiteCambioFProceso==='S' && this.state.permitirGeneracionProforma && this.state.operacion==='G') }
                  func_onChange={(fecha)=>this.setState({fechaProforma: fecha})}/>
              </ContainerCol>
              <ContainerCol className='col-sm-3'>
                <LabelForm>Cliente:</LabelForm>
                <ReactSelectAsync value={this.state.cliente_sel} disabled={!(this.state.permitirGeneracionProforma && this.state.operacion==='G')}
                  func_loadOptions={this.getOptions_Clientes}
                  func_onChange={(value)=>{if(Array.isArray(value)){value=null;} this.setState({cliente_sel: value, tipoCliente_sel: null, vendedor_sel: null, direccion_sel: null, descuentosCliente: []})}}
                  func_onBlur={this.getClientebyId}
                />
              </ContainerCol>
              <ContainerCol className='col-sm-2'>
                <LabelForm>Tipo Cliente:</LabelForm>
                <ReactSelect options={ this.state.tiposCliente } disabled={true} value={this.state.tipoCliente_sel} func_onChange={(value)=>{this.setState({tipoCliente_sel: value})}}/>
              </ContainerCol>
              <ContainerCol className='col-sm-3'>
                <LabelForm>Vendedor:</LabelForm>
                <ReactSelectAsync value={this.state.vendedor_sel} disabled={!(this.state.permitirGeneracionProforma && this.state.operacion==='G')}
                  func_loadOptions={this.getOptions_Vendedores}
                  func_onChange={(value)=>{if(Array.isArray(value)){value=null;} this.setState({vendedor_sel: value})}}/>
              </ContainerCol>
            </Row>
            <Row>               
              <ContainerCol className='col-sm-4'>
                <LabelForm>Dirección de Envío:</LabelForm>
                <ReactSelect searchable={false} options={ this.state.direccionesCliente } value={this.state.direccion_sel} disabled={!(this.state.permitirGeneracionProforma || this.state.permitirModifCabProforma)}
                     func_onChange={(value) => this.setState({direccion_sel: value===null?null:value.value})}/>
              </ContainerCol>
              <ContainerCol className='col-sm-2'>
                <LabelForm>Forma Pago:</LabelForm>
                <ReactSelect options={this.state.formasPago} value={this.state.formaPago_sel} disabled={!(this.state.permitirGeneracionProforma && this.state.operacion==='G')}
                  func_onChange={(value)=>
                    { let formaPago=(value!==null)?value.value:null;
                      let clienteId = (this.state.cliente_sel!==null && this.state.cliente_sel!==undefined)?this.state.cliente_sel.value:null;

                      if (formaPago==='CN'){
                        this.setState({formaPago_sel: formaPago, terminoPago_sel: null}, ()=>{
                          this.aplicarDescuentosPorCliente(clienteId, formaPago);
                        });
                      }else{
                        this.setState({formaPago_sel: formaPago}, ()=>{
                          this.aplicarDescuentosPorCliente(clienteId, formaPago);
                        });
                      }
                    }}/>
              </ContainerCol>
              <ContainerCol className='col-sm-2'>
                <LabelForm>Termino Pago:</LabelForm>
                <ReactSelect disabled={!((this.state.permitirGeneracionProforma || this.state.permitirModifCabProforma)&&this.state.habilitarTerPago)}
                    options={ this.state.terminosPago } value={this.state.terminoPago_sel}
                    func_onChange={(value)=>{this.changeFormaPago(value)}}/>
              </ContainerCol>
              <ContainerCol className='col-sm-2'>
                <LabelForm>Estado:</LabelForm>
                <ReactSelect options={ this.state.estadosProforma } disabled={true} value={this.state.estadoActual}/>
              </ContainerCol>
              <ContainerCol className='col-sm-2' isInvisible={this.state.estadoActual==='F'}>
                <LabelForm>Pto. Facturación:</LabelForm>
                <PuntoFacturacion disabled={true}/>
              </ContainerCol>
              <ContainerCol className='col-sm-2' isInvisible={this.state.estadoActual!=='F'}>
                <LabelForm>Nro. Factura:</LabelForm>
                <LabelNroFactura>{this.state.nroFactura}</LabelNroFactura>
              </ContainerCol>
            </Row>
            <Row>
              <ContainerCol className='col-sm-4'>
                <LabelForm>Artículo:</LabelForm>
                <SelectArticulo tipoArticulos={this.state.esProformaServicio?'S':'P'} value={this.state.articulo_sel}
                  func_onChange={(value)=>{if(Array.isArray(value)){value=null;} this.setState({articulo_sel: value})}}/>
              </ContainerCol>
              <ContainerCol className='col-sm-1'>
                <LabelForm>Cantidad:</LabelForm>
                <InputText autoComplete='off' name='cantidadArt' value={this.state.cantidadArt===undefined?'':this.state.cantidadArt} type='number' className='form-control input-sm' placeholder='Cant.' onChange={this.handleInputChange}/>
              </ContainerCol>
              <ContainerCol isInvisible={!this.state.esProformaServicio} className='col-sm-4'>
                <LabelForm>Descripción|Precio:</LabelForm>
                <InputText ancho={75} autoComplete='off' mayusculas={true} name='descripcionArt' value={this.state.descripcionArt} type='text' className='form-control input-sm' placeholder='Descripción del servicio' maxLength={80} onChange={this.handleInputChange}/>
                <InputText ancho={25} autoComplete='off' name='precioUnitArt' value={this.state.precioUnitArt} type='number' className='form-control input-sm' placeholder='P. Unit.' onChange={this.handleInputChange}/>
              </ContainerCol>
              <ContainerCol className='col-sm-1'>
                <ContenedorBoton>
                <Tooltip placement='right' overlay='Añadir/Quitar un artículo'>
                  <div className='btn-group pull-left'>
                    <button type='button' className='btn btn-success btn-sm' disabled={!this.state.permitirModifDetProformaAgregar} onClick={this.handleAddArticulo}><i className='fa fa-plus'/></button>
                    <button type='button' className='btn btn-danger btn-sm' disabled={!this.state.permitirModifDetProformaEliminar} onClick={this.handleDeleteArticulo}><i className='fa fa-window-close'/></button>
                  </div>
                </Tooltip>
                </ContenedorBoton>
              </ContainerCol>
              <ContainerCol className='col-sm-offset-3 col-sm-1' isInvisible={(promocionVigente === null || this.state.esProformaServicio===true)}>
                <ContenedorBoton>
                  <Tooltip placement='right' overlay='Añadir/Modificar artículos de Promoción'>
                    <button type='button' className='btn btn-danger btn-sm' onClick={this.cambiarVisualizacionModalPromociones}><i className='fa fa-certificate'/> Promociones</button>
                  </Tooltip>
                </ContenedorBoton>
              </ContainerCol>
            </Row>
            <Row>
              <div className='col-sm-11'>
                <Row>
                  <div className='col-sm-12'>
                    <AgGridRender altura='355px' alturaRow={25} data={this.state.detalleProforma} columnas={this.state.colsDefDetProforma}
                      gridOptions={this.gridDetProformaOptions} onGridReady={this.onGridDetProformaReady}/>
                  </div>
                </Row>
                <Row>
                  <div className='col-sm-6'>
                    <LabelNota>* Haga doble clic sobre el código o descripción del artículo para visualizar reporte del stock que tiene disponible.</LabelNota>
                  </div>
                  <div className='col-sm-6 pull-right'>
                    <LabelNotaConEstilo fontSize={12}>
                      {this.state.descuentosCliente.length>0?'El cliente seleccionado tiene descuentos habilitados:':''}
                      {this.state.descuentosCliente.map(dsctoCli=>{
                        if (dsctoCli.TipoDescuento === 'T'){
                          return `.- Con Forma de Pago: ${dsctoCli.FormaPago} Dscto: ${dsctoCli.PDescuento}% sobre Total Neto.`;
                        }else{
                          if (dsctoCli.EfectoDescProducto==='T'){
                            return `.- Con Forma de Pago: ${dsctoCli.FormaPago} Dscto: ${dsctoCli.PDescuento}% en todos los artículos.`;
                          }else{
                            let msgDsctosPorLinea = `.- Con Forma de Pago: ${dsctoCli.FormaPago} en artículos seleccionados: `;
                            msgDsctosPorLinea += dsctoCli.dsctoLineas.map(dsctoLinea=>{
                              return ` ${dsctoLinea.tipoCompra.Descripcion} Dscto: ${dsctoLinea.PDescuento}% `;
                            })
                            return msgDsctosPorLinea;
                          }
                        }
                      })}
                    </LabelNotaConEstilo>
                  </div>
                </Row>
              </div>
              <div className='col-sm-1'>
                <Row>
                  <ContainerBtnTransac className='col-sm-12'>                    
                    <Tooltip placement='right' overlay={'Importar/Visualizar Pedidos'}>
                      <button type='button' className='btn btn-default btn-sm' disabled={!this.state.permitirGeneracionProforma} onClick={this.cambiarVisualizacionModalPedidos}>
                          <i className='fa fa-cloud-download fa-lg'/></button>
                    </Tooltip>
                  </ContainerBtnTransac>
                </Row>
                <Row>
                  <ContainerBtnTransac className='col-sm-12'>
                      <Tooltip placement='left' overlay={'Ver Proformas Pendientes de Imprimir'}>
                          <button type='button' className='btn secondary btn-sm'
                                  disabled={!this.state.permitirConsultaProformasXImprimir}
                                  onClick={()=> {
                                      this.setState({ isVisibleModalProfPendImprimir: true }, () => this.props.cargar_Proformas('PendientesImprimirBodega'));
                                  }}>
                              <i className='fa fa-list fa-lg'/>
                          </button>
                      </Tooltip>
                  </ContainerBtnTransac>
                </Row>
                <Row>
                  <ContainerBtnTransac className='col-sm-12'>
                    <Tooltip placement='right' overlay={'Guardar Proforma'}>
                      <button type='button' className='btn btn-primary btn-sm' disabled={!( this.state.permitirGeneracionProforma ||
                                                                                            this.state.permitirModifCabProforma ||
                                                                                            this.state.permitirModifDetProformaAgregar ||
                                                                                            this.state.permitirModifDetProformaEliminar ||
                                                                                            this.state.permitirModifDetProformaCambiar ||
                                                                                            this.state.permitirModifDetProformaCambiarLimitado)}
                              onClick={this.guardarProforma}><i className='fa fa-floppy-o fa-lg'/></button>
                    </Tooltip>
                  </ContainerBtnTransac>
                </Row>
                <Row>
                  <ContainerBtnTransac className='col-sm-12'>
                    <Tooltip placement='right' overlay={'Imprimir Proforma'}>
                      <button type='button' className='btn btn-info btn-sm' onClick={this.imprimirProforma}><i className='fa fa-print fa-lg'/></button>
                    </Tooltip>
                  </ContainerBtnTransac>
                </Row>
                <Row>
                  <ContainerBtnTransac className='col-sm-12'>
                    <Tooltip placement='right' overlay={'Replicar Proforma'}>
                      <button type='button' className='btn btn-warning btn-sm' disabled={!this.state.permitirGeneracionProforma} onClick={this.replicarProforma}>
                          <i className='fa fa-files-o'/></button>
                    </Tooltip>
                  </ContainerBtnTransac>
                </Row>
                <Row>
                  <ContainerBtnTransac className='col-sm-12'>
                    <Tooltip placement='left' overlay={'Limpiar Pantalla y Cancelar Reserva de Stock'}>
                      <button type='button' className='btn btn-default btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'/></button>
                    </Tooltip>
                  </ContainerBtnTransac>
                </Row>
                <Row>
                  <ContainerBtnTransac className='col-sm-12'>
                    <Tooltip placement='right' overlay={'Anular Proforma'}>
                      <button type='button' className='btn btn-danger btn-sm' disabled={!this.state.permitirAnulacionProforma} onClick={this.anularProforma}>
                          <i className='fa fa-minus-circle fa-lg'/></button>
                    </Tooltip>
                  </ContainerBtnTransac>
                </Row>
                <Row>
                  <ContainerBtnTransac className='col-sm-12'>
                    <Tooltip placement='left' overlay={'Ver Proformas Pendientes de Facturar'}>
                      <button type='button' className='btn btn-default btn-sm' disabled={!this.state.permitirFacturacion} onClick={this.cambiarVisualizacionModalProfPendFact}>
                          <i className='fa fa-filter fa-lg'/></button>
                    </Tooltip>
                  </ContainerBtnTransac>
                </Row>
                <Row>
                  <ContainerBtnTransac className='col-sm-12'>
                    <Tooltip placement='right' overlay={'Generar Factura'}>
                      <button type='button' className='btn btn-success btn-sm' disabled={!this.state.permitirFacturacion} onClick={this.validarGeneracionFactura}>
                          <i className='fa fa-file-text-o fa-lg'/></button>
                    </Tooltip>
                  </ContainerBtnTransac>
                </Row>               
                <Row>
                  <ContainerBtnTransac className='col-sm-12'>
                    <Tooltip placement='right' overlay={'Imprimir Factura'}>
                      <button type='button' className='btn btn-info btn-sm' disabled={!this.state.permitirFacturacion} onClick={this.imprimirFactura}>
                          <i className='fa fa-print fa-lg'/></button>
                    </Tooltip>
                  </ContainerBtnTransac>
                </Row>
              </div>
            </Row>
            <Row isInvisible={this.state.ocultarValoresProforma}>
              <div className='col-sm-1'>
                <LabelTotales>Base Iva:</LabelTotales>
              </div>
              <div className='col-sm-1'>
                <LabelTotales>Base Sin Iva:</LabelTotales>
              </div>
              <div className='col-sm-2'>
                <LabelTotales>Dscto. Línea:</LabelTotales>
              </div>            
              <div className='col-sm-2'>
                <LabelTotales>{`Dscto. Global(${this.state.porcentajeDscto}%):`}</LabelTotales>
              </div>       
              <div className='col-sm-2'>
                <LabelTotales>{`Dscto. Por Plazo(${this.state.porcentajeDsctoPlazo}%):`}</LabelTotales>
              </div>        
              <div className='col-sm-1'>
                <LabelTotales>% Iva: </LabelTotales>
              </div>
              <div className='col-sm-1'>
                <LabelTotales>Iva: </LabelTotales>
              </div>
              <div className='col-sm-2'>
                <LabelTotales>Total: </LabelTotales>
              </div>
            </Row>
            <Row isInvisible={this.state.ocultarValoresProforma}>
              <div className='col-sm-1'>
                <LabelValorTotales>{formatearNumeroDecimal(this.state.subtotalConIva)}</LabelValorTotales>
              </div>
              <div className='col-sm-1'>
                <LabelValorTotales>{formatearNumeroDecimal(this.state.subtotalSinIva)}</LabelValorTotales>
              </div>
              <div className='col-sm-2'>
                <LabelValorTotales>{formatearNumeroDecimal(this.state.totalDsctoLinea)}</LabelValorTotales>
              </div>
              <div className='col-sm-2'>
                <LabelValorTotales>{formatearNumeroDecimal(this.state.totalDscto)}</LabelValorTotales>
              </div>    
              <div className='col-sm-2'>
                <LabelValorTotales>{formatearNumeroDecimal(this.state.totalDsctoPlazo)}</LabelValorTotales>
              </div>            
              <div className='col-sm-1'>
                <LabelValorTotales>{this.state.porcentIva}</LabelValorTotales>
              </div>
              <div className='col-sm-1'>
                <LabelValorTotales>{formatearNumeroDecimal(this.state.valorIva)}</LabelValorTotales>
              </div>
              <div className='col-sm-2'>
                <LabelValorTotales>{formatearNumeroDecimal(this.state.total)}</LabelValorTotales>
              </div>
            </Row>
          </CuerpoForm>
        </ContenedorForm>      
        <ModalResponsive open={this.state.isVisibleModalPedidos} onClose={()=>this.setState({isVisibleModalPedidos: false})}>
          <ContenedorModal>
            <Row>
              <div className='col-sm-12'>
                <Tabs>
                  <TabList>
                    <Tab>Pedidos para generar proforma</Tab>
                    <Tab>Pedidos entrantes</Tab>
                  </TabList>
                  <TabPanel>
                    <Row>
                      <div className='col-sm-12'>
                        <AgGridRender altura='300px' data={this.state.pedidosPendientesProforma} columnas={this.state.colsDefPedidos} 
                          gridOptions={this.gridPedidosOptions}/>
                      </div>
                    </Row>
                    <Row>
                      <div className='col-sm-12'>
                        <LabelNota>* Haga doble clic sobre el pedido del cual desea generar la proforma.</LabelNota>
                      </div>
                    </Row>
                  </TabPanel>
                  <TabPanel>
                    <Row>
                      <div className='col-sm-12'>
                        <AgGridRender altura='320px' data={this.state.pedidosMovilesNuevos} columnas={this.state.colsDefPedidosNuevos} 
                          gridOptions={this.gridPedidosNuevosOptions}/>
                      </div>
                    </Row>
                  </TabPanel>
                </Tabs>
              </div>
            </Row>           
            <Row>
              <div className='col-sm-12'>
                <div className='btn-group pull-right'>
                  <button type='button' className='btn btn-success btn-sm' onClick={this.procesarConsultaPedidos}><i className='fa fa-refresh fa-lg'/> Actualizar</button>
                  <button type='button' className='btn btn-danger btn-sm' onClick={()=>this.setState({isVisibleModalPedidos: false})}><i className='fa fa-times-circle fa-lg'/> Cerrar</button>
                </div>
              </div>
            </Row>
          </ContenedorModal>
        </ModalResponsive>
        <ModalResponsive open={this.state.isVisibleModalProfPendFact} onClose={()=>this.setState({isVisibleModalProfPendFact:false, esDetallePendiente:false,proformasPendFact:[]})}>
          <ContenedorModal>
            <Row>
              <div className='col-sm-12'>
                <LabelForm>Proformas pendientes de facturar</LabelForm>
              </div>
            </Row>
            <Row>
              <div className='col-sm-12'>
                <AgGridRender altura='320px' data={this.state.proformasPendFactura} columnas={this.state.colsDefListadoProformas}
                  gridOptions={this.gridProfPendFactOptions}/>
              </div>
            </Row>
            <Row>
              {
                this.state.esDetallePendiente?
                null:
                <div className='col-sm-12'>
                  <div className='btn-group pull-right'>
                    <button type='button' className='btn btn-success btn-sm' onClick={this.procesarConsultaProfPendFacturar}><i className='fa fa-refresh fa-lg'/> Actualizar</button>
                    <button type='button' className='btn btn-danger btn-sm' onClick={()=>this.setState({isVisibleModalProfPendFact:false, esDetallePendiente:false,proformasPendFact:[]})}><i className='fa fa-times-circle fa-lg'/> Cerrar</button>
                  </div>
                </div>
              }
            </Row>
            <Row>
              <div className='col-sm-12'>
                <LabelNota>* Haga doble clic sobre la proforma que desea facturar.</LabelNota>
              </div>
            </Row>
          </ContenedorModal>
        </ModalResponsive>
        <ModalResponsive open={this.state.isVisibleModalProfPendImprimir} onClose={()=>this.setState({isVisibleModalProfPendImprimir: false})}>
          <ContenedorModal>
              <Row>
                  <div className='col-sm-12'>
                      <LabelForm>Proformas pendientes de imprimir en Bodega: ({this.props.proformas.length} resultados)</LabelForm>
                  </div>
              </Row>
              <Row>
                  <div className='col-sm-12'>
                      <AgGridRender altura='320px' data={this.props.proformas} columnas={this.state.colsDefListadoProformas}
                                    gridOptions={this.gridProfPendImprimirOptions}/>
                  </div>
              </Row>
              <Row>
                  <div className='col-sm-7'>
                      <LabelNota>* Haga doble clic sobre la proforma que desea visualizar.</LabelNota>
                  </div>
                  <div className='col-sm-5'>
                      <div className='btn-group pull-right'>
                          <button type='button' className='btn btn-success btn-sm' onClick={()=>this.props.cargar_Proformas('PendientesImprimirBodega')}><i className='fa fa-refresh fa-lg'/> Actualizar</button>
                          <button type='button' className='btn btn-danger btn-sm' onClick={()=>this.setState({isVisibleModalProfPendImprimir: false})}><i className='fa fa-times-circle fa-lg'/> Cerrar</button>
                      </div>
                  </div>
              </Row>
          </ContenedorModal>
        </ModalResponsive>
        <DocumentosGeneradosPorImprimir
          tipoComprob={'PROF'}
          isVisibleCompGenPorImp={this.state.isVisibleCompGenPorImp}          
          tituloDocPorImp='Proformas generadas/actualizadas por imprimir'          
          onClose = {()=>{this.setState({isVisibleCompGenPorImp: false}); this.props.setDocumentosPorImprimir([]);}}
        />
        <ModalResponsive open={this.state.isVisibleModalPromociones} onClose={()=>{this.setState({isVisibleModalPromociones:false})}}>
          <ContenedorModal>            
            <Row>
              <div className='col-sm-8'>
                <Row>
                  <div className='col-sm-12'>
                    <LabelForm>Promoción Activa:</LabelForm>
                    <LabelNormal>{(promocionVigente!==null)?`${promocionVigente.tipoPromo.Descripcion} - ${promocionVigente.tipoPromo.Observacion}`:''}</LabelNormal>
                  </div>
                </Row>
                <Row>
                  <div className='col-sm-12'>
                    <LabelForm>Detalle de Promoción:</LabelForm>
                    { lineasArticEnPromoc.map(itLineaPromo=>{
                        return <LabelNormal>{`Por la venta de ${itLineaPromo.CantidadBase} uds. de la línea: ${itLineaPromo.tipoCompra.Codigo} - ${itLineaPromo.tipoCompra.Descripcion} se regala ${itLineaPromo.CantidadRegalo} uds.`}</LabelNormal>
                      })
                    }
                  </div>
                </Row>
              </div>
              <div className='col-sm-2'>
                <LabelForm>Artículos en Promoción Vendidos:</LabelForm>
                <LabelTotales>{cantItemsEnPromocionVend}</LabelTotales>
              </div>
              <div className='col-sm-2'>
                <LabelForm>Artículos Regalados:</LabelForm>
                <LabelTotales>{cantItemsRegalados}</LabelTotales>
              </div>
            </Row>
            <Row>
              <div className='col-sm-12'>
                <LabelForm>Artículos en Promoción:</LabelForm>
              </div>
            </Row>
            <Row>
              <div className='col-sm-12'>
                <AgGridRender altura='350px' data={this.state.itemsPromocion} columnas={this.state.colsDefItemsPromocion}
                  gridOptions={this.gridItemsPromocion}/>
              </div>
            </Row>
            <Row>
              <div className='col-sm-12'>
                <div className='btn-group pull-right'>
                  <button type='button' className='btn btn-primary btn-sm' onClick={this.generarItemsPromocionEnProforma}><i className='fa fa-plus-circle fa-lg'/> Añadir Art. Promoc.</button>
                  <button type='button' className='btn btn-danger btn-sm' onClick={this.cambiarVisualizacionModalPromociones}><i className='fa fa-times-circle fa-lg'/> Cerrar</button>
                </div>
              </div>
            </Row>
          </ContenedorModal>
        </ModalResponsive>
    </div>
    );
  }
}

const mapStateToProps = ((state) => {
  return {isVisibleLoading: state.ui.isVisibleLoading,
          idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
          puntoFacturacionSel: state.ventas.ptoFacturacionSel,
          articulo: state.inventario.articulo_Sel,
          permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
          diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
          puntosFacturacion: state.ventas.puntosFact,
          proformas: state.ventas.proformas
  };
});

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ cambiar_VisualizacionLoading, generar_LogAuditoriaIngresoForm,
    generar_LogAuditoriaSalidaForm, cargar_Articulo, cargar_Proformas, setDocumentosPorImprimir
  }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormVen02);